// Generated by scripts/generate_frontend_contracts.py. Do not edit manually.
/**
 * @typedef {Object} ApiErrorDto
 * @property {unknown} success
 * @property {string} error
 * @property {string} message
 * @property {string} code
 * @property {Record<string, unknown>} details
 * @property {string} request_id
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} BotMutationRequestDto
 * @property {string} name
 * @property {Record<string, unknown>} basic
 */

/**
 * @typedef {Object} BotMutationResponseDto
 * @property {string} id
 * @property {string} name
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} BotPerformanceHistoryResponseDto
 * @property {Record<string, unknown>|null} baseline
 * @property {Array<Record<string, unknown>>} releases
 * @property {Record<string, unknown>} pagination
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} BotPerformanceResponseDto
 * @property {unknown} schemaVersion
 * @property {Array<Record<string, unknown>>} [confirmedLatency]
 * @property {string} botId
 * @property {unknown} botType
 * @property {boolean} available
 * @property {string} [reason]
 * @property {Record<string, unknown>} retention
 * @property {unknown} serviceStatus
 * @property {number} droppedEvents
 * @property {Record<string, unknown>} release
 * @property {Record<string, unknown>} filters
 * @property {Record<string, unknown>} baseline
 * @property {unknown} state
 * @property {Record<string, unknown>} metrics
 * @property {Record<string, unknown>} [phaseMetrics]
 * @property {Array<Record<string, unknown>>} [history]
 * @property {Record<string, unknown>} outcomeMetrics
 * @property {Record<string, unknown>} comparison
 * @property {Array<Record<string, unknown>>} traces
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} BotPositionResponseDto
 * @property {boolean} success
 * @property {unknown} position
 * @property {string} source
 * @property {number|number|null} [next_candle_check_seconds]
 * @property {string|number|null} [current_capital]
 * @property {string|number|null} [initial_deposit]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} BotTradesResponseDto
 * @property {unknown} success
 * @property {Array<unknown>} [deals]
 * @property {Array<Record<string, unknown>>} [cycles]
 * @property {Array<Record<string, unknown>>} [purchases]
 * @property {string|null} [nextCursor]
 * @property {string} [historyType]
 * @property {boolean} [historyUnavailable]
 * @property {Record<string, unknown>} [summary]
 * @property {Record<string, unknown>} [pagination]
 * @property {Record<string, unknown>} metrics
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} CollectionResponseDto
 * @property {Array<unknown>} items
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} CombinedTradeJournalCalendarResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} CombinedTradeJournalDayResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} CombinedTradeJournalMonthResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} DcaCycleBudgetRequestDto
 * @property {string} apiKeyName
 * @property {unknown} marketType
 * @property {string|number} cycleAllocationPercent
 * @property {string|number} leverage
 */

/**
 * @typedef {Object} DcaCycleBudgetResponseDto
 * @property {Record<string, unknown>} preview
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} DcaPreviewRequestDto
 * @property {Record<string, unknown>} basic
 * @property {Record<string, unknown>} dca
 */

/**
 * @typedef {Object} DcaPreviewResponseDto
 * @property {Record<string, unknown>} preview
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} DeploymentArtifactsResponseDto
 * @property {unknown} api_version
 * @property {unknown} schema_version
 * @property {unknown} format_version
 * @property {string} active_sha
 * @property {string} target_sha
 * @property {boolean} deploying
 * @property {string} generated_at
 */

/**
 * @typedef {Object} DiskRefreshResponseDto
 * @property {unknown} success
 * @property {unknown} accepted
 * @property {boolean} refreshing
 * @property {boolean} refresh_requested
 * @property {Record<string, unknown>|null} snapshot
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} HomeNewsFeedDto
 * @property {string} api_version
 * @property {string} schema_version
 * @property {boolean} refreshEnabled
 * @property {string|null} frozenAt
 * @property {Array<Record<string, unknown>>} items
 * @property {boolean} hasMore
 * @property {string|null} nextCursor
 */

/**
 * @typedef {Object} HomeNewsSettingsDto
 * @property {string} api_version
 * @property {string} schema_version
 * @property {boolean} refreshEnabled
 * @property {string|null} frozenAt
 */

/**
 * @typedef {Object} JournalDashboardResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} JournalPositionsResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} JournalTradesResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} LogWindowResponseDto
 * @property {string} api_version
 * @property {string} schema_version
 * @property {string} logs
 * @property {string} [mode]
 * @property {string} [cursor]
 * @property {Record<string, unknown>} window
 */

/**
 * @typedef {Object} OpenaiUsageSnapshotsResponseDto
 * @property {Array<Record<string, unknown>>} snapshots
 * @property {Record<string, unknown>} pagination
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} OrderPreviewRequestDto
 * @property {string|number} order_value
 * @property {string|number} price
 * @property {string|number} [qty_step]
 * @property {string|number} [min_order_qty]
 * @property {string|number} [min_notional_value]
 */

/**
 * @typedef {Object} OrderPreviewResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PerformanceRegressionAckResponseDto
 * @property {Record<string, unknown>} regression
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PerformanceRegressionsResponseDto
 * @property {Array<Record<string, unknown>>} regressions
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PerformanceReleasesResponseDto
 * @property {Array<Record<string, unknown>>} releases
 * @property {Record<string, unknown>} pagination
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PerformanceTraceResponseDto
 * @property {Record<string, unknown>} trace
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingBalanceHistoryResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingCalendarResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingDayResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingKeysResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingMonthResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingResolveResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingSummaryResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingSyncSettingsResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PersonalTradingUnclassifiedResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} PositionDto
 * @property {string} [symbol]
 * @property {string|number} [size]
 * @property {string|number} [entry_price]
 * @property {string|number|null} [roi]
 */

/**
 * @typedef {Object} PositionsResponseDto
 * @property {Array<unknown>} positions
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} RuntimeActionResponseDto
 * @property {string} status
 * @property {string} [message]
 * @property {number|null} [started_at]
 * @property {number|null} [stopped_at]
 * @property {number|null} [duration_ms]
 * @property {number} [lifecycle_version]
 * @property {string|null} [lifecycle_updated_at]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} RuntimeStatusDto
 * @property {string} [bot_id]
 * @property {string} status
 * @property {string|null} [confirmed_status]
 * @property {string} [updated_at]
 * @property {number} [lifecycle_version]
 * @property {string|null} [lifecycle_updated_at]
 * @property {number|string|null} [started_at]
 * @property {number|null} [stopped_at]
 * @property {number|null} [duration_ms]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} RuntimeSummariesResponseDto
 * @property {Record<string, unknown>} summaries
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} SecurityEventAckResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} event
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} SecurityEventsResponseDto
 * @property {unknown} success
 * @property {Array<Record<string, unknown>>} items
 * @property {string|null} next_cursor
 * @property {Record<string, unknown>} pagination
 * @property {string} generated_at
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} SecuritySummaryResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} ServerDiagnosticsResponseDto
 * @property {unknown} success
 * @property {unknown} state
 * @property {Record<string, unknown>|null} snapshot
 * @property {boolean} refreshing
 * @property {boolean} refresh_requested
 * @property {string|null} [refresh_requested_at]
 * @property {string|null} [refresh_started_at]
 * @property {string|null} [last_refresh_error]
 * @property {string|null} [next_refresh_at]
 * @property {Record<string, unknown>|null} [storage_alert]
 * @property {string} generated_at
 * @property {Record<string, unknown>} [deployment]
 * @property {Record<string, unknown>} [deployment_status]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} ServerServicesResponseDto
 * @property {unknown} success
 * @property {Array<Record<string, unknown>>} services
 * @property {string} generated_at
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} StackRestartResponseDto
 * @property {boolean} ok
 * @property {string} [stdout]
 * @property {string} [stderr]
 * @property {string} [error]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradeDto
 * @property {string} [deal_id]
 * @property {string|number|null} [net_profit]
 * @property {string|number|null} [start_time]
 * @property {Record<string, unknown>} [display]
 */

/**
 * @typedef {Object} TradeJournalCalendarResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradeJournalDayResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradeJournalMonthResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradeJournalTestDataResponseDto
 * @property {unknown} success
 * @property {number} affected_count
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradeMetricsRequestDto
 * @property {Array<Record<string, unknown>>} trades
 */

/**
 * @typedef {Object} TradeMetricsResponseDto
 * @property {unknown} success
 * @property {Record<string, unknown>} data
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} TradesResponseDto
 * @property {Array<unknown>} deals
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} VersionedResponseDto
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} WebsocketDiagnosticsDto
 * @property {unknown} diagnostic_version
 * @property {string|null} cause
 * @property {string|null} [client_release]
 * @property {unknown} confidence
 * @property {string|null} [connection_id]
 * @property {string|null} [consumer]
 * @property {string|null} [incident_id]
 * @property {unknown} [initiator]
 * @property {string|null} [occurred_at]
 * @property {unknown} [protocol]
 * @property {string|null} [server_connection_id]
 * @property {string|null} [server_instance_id]
 * @property {string|null} [server_release]
 * @property {unknown} [sync_result]
 * @property {string|null} [tab_id]
 * @property {unknown} [visibility]
 * @property {number|null} [ack_age_ms]
 * @property {number|null} [attempts]
 * @property {number|null} [close_code]
 * @property {number|null} [dropped_records]
 * @property {number|null} [duration_ms]
 * @property {number|null} [incoming_age_ms]
 * @property {number|null} [rtt_ms]
 * @property {number|null} [sequence]
 * @property {number|null} [timer_lag_ms]
 * @property {boolean|null} [browser_online]
 * @property {boolean|null} [was_clean]
 */

/**
 * @typedef {Object} WebsocketEventDto
 * @property {string} type
 * @property {string} timestamp
 * @property {string} [bot_id]
 * @property {number|null} [started_at]
 * @property {number|null} [stopped_at]
 * @property {number|null} [duration_ms]
 * @property {number} [lifecycle_version]
 * @property {string|null} [lifecycle_updated_at]
 * @property {string} api_version
 * @property {string} schema_version
 */

/**
 * @typedef {Object} WebsocketHeartbeatAckDto
 * @property {unknown} type
 * @property {unknown} protocol_version
 * @property {number} sequence
 * @property {string} connection_id
 * @property {string} server_connection_id
 * @property {string} server_instance_id
 * @property {string} server_release
 */

/**
 * @typedef {Object} WebsocketHeartbeatV2Dto
 * @property {unknown} type
 * @property {unknown} protocol_version
 * @property {number} sequence
 * @property {string} connection_id
 */

export const API_VERSION = "1"
export const SCHEMA_VERSION = "1"
export const CONTRACT_SCHEMAS = Object.freeze({
  "api_error": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "code": {
        "minLength": 1,
        "type": "string"
      },
      "details": {
        "type": "object"
      },
      "error": {
        "type": "string"
      },
      "message": {
        "type": "string"
      },
      "request_id": {
        "minLength": 1,
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": false
      }
    },
    "required": [
      "success",
      "error",
      "message",
      "code",
      "details",
      "request_id",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "bot_mutation_request": {
    "properties": {
      "basic": {
        "properties": {
          "botType": {
            "enum": [
              "dca",
              "strategy"
            ],
            "type": "string"
          },
          "marketType": {
            "enum": [
              "linear",
              "spot"
            ],
            "type": "string"
          },
          "pair": {
            "minLength": 1,
            "type": "string"
          },
          "tradeType": {
            "enum": [
              "LONG",
              "SHORT",
              "SPOT",
              "long",
              "short",
              "spot"
            ],
            "type": "string"
          }
        },
        "required": [
          "pair",
          "marketType",
          "botType",
          "tradeType"
        ],
        "type": "object"
      },
      "name": {
        "minLength": 1,
        "type": "string"
      }
    },
    "required": [
      "name",
      "basic"
    ],
    "type": "object"
  },
  "bot_mutation_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "id": {
        "minLength": 1,
        "type": "string"
      },
      "name": {
        "minLength": 1,
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "id",
      "name",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "bot_performance_history_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "baseline": {
        "type": [
          "object",
          "null"
        ]
      },
      "pagination": {
        "properties": {
          "page": {
            "minimum": 1,
            "type": "integer"
          },
          "pageSize": {
            "maximum": 100,
            "minimum": 1,
            "type": "integer"
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "page",
          "pageSize",
          "total"
        ],
        "type": "object"
      },
      "releases": {
        "items": {
          "properties": {
            "activity": {
              "type": "object"
            },
            "baselineTag": {
              "type": "string"
            },
            "commitSha": {
              "type": "string"
            },
            "commitSubject": {
              "type": "string"
            },
            "commitType": {
              "type": "string"
            },
            "comparison": {
              "type": [
                "object",
                "null"
              ]
            },
            "deployedAt": {
              "type": [
                "string",
                "null"
              ]
            },
            "deploymentId": {
              "type": "string"
            },
            "environment": {
              "type": "string"
            },
            "metrics": {
              "type": "object"
            },
            "performanceCommit": {
              "type": "boolean"
            },
            "readyCohortCount": {
              "minimum": 0,
              "type": "integer"
            },
            "regressionAttribution": {
              "properties": {
                "ageDays": {
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "healthySampleCount": {
                  "minimum": 0,
                  "type": "integer"
                },
                "healthySampleTarget": {
                  "minimum": 1,
                  "type": "integer"
                },
                "hotUntil": {
                  "type": "string"
                },
                "hotWindowDays": {
                  "minimum": 1,
                  "type": "integer"
                },
                "priority": {
                  "enum": [
                    "not_applicable",
                    "primary",
                    "cooling",
                    "validated",
                    "historical"
                  ]
                },
                "profile": {
                  "type": "string"
                },
                "reasonCode": {
                  "type": "string"
                },
                "risk": {
                  "type": "string"
                },
                "scope": {
                  "items": {
                    "type": "string"
                  },
                  "type": "array"
                },
                "warmUntil": {
                  "type": "string"
                },
                "warmWindowDays": {
                  "minimum": 1,
                  "type": "integer"
                }
              },
              "type": "object"
            },
            "sampleCount": {
              "minimum": 0,
              "type": "integer"
            },
            "status": {
              "enum": [
                "baseline",
                "improved",
                "regressed",
                "unchanged",
                "insufficient_data",
                "activity_only",
                "unknown_scope"
              ]
            },
            "tradingLogicCommit": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "tradingLogicPaths": {
              "items": {
                "type": "string"
              },
              "type": "array"
            }
          },
          "required": [
            "deploymentId",
            "commitSha",
            "status",
            "sampleCount",
            "metrics"
          ],
          "type": "object"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "baseline",
      "releases",
      "pagination",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "bot_performance_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "available": {
        "type": "boolean"
      },
      "baseline": {
        "type": "object"
      },
      "botId": {
        "type": "string"
      },
      "botType": {
        "enum": [
          "dca",
          "strategy"
        ]
      },
      "comparison": {
        "properties": {
          "postEntry": {
            "type": "object"
          }
        },
        "type": "object"
      },
      "confirmedLatency": {
        "items": {
          "type": "object"
        },
        "type": "array"
      },
      "droppedEvents": {
        "minimum": 0,
        "type": "integer"
      },
      "filters": {
        "type": "object"
      },
      "history": {
        "items": {
          "type": "object"
        },
        "maxItems": 90,
        "type": "array"
      },
      "metrics": {
        "type": "object"
      },
      "outcomeMetrics": {
        "type": "object"
      },
      "phaseMetrics": {
        "type": "object"
      },
      "reason": {
        "type": "string"
      },
      "release": {
        "properties": {
          "baselineTag": {
            "type": "string"
          },
          "commitSha": {
            "type": "string"
          },
          "commitSubject": {
            "type": "string"
          },
          "commitType": {
            "type": "string"
          },
          "deployedAt": {
            "type": "string"
          },
          "deploymentId": {
            "type": "string"
          },
          "environment": {
            "type": "string"
          },
          "performanceCommit": {
            "type": "boolean"
          },
          "regressionAttribution": {
            "properties": {
              "ageDays": {
                "type": [
                  "number",
                  "null"
                ]
              },
              "healthySampleCount": {
                "minimum": 0,
                "type": "integer"
              },
              "healthySampleTarget": {
                "minimum": 1,
                "type": "integer"
              },
              "hotUntil": {
                "type": "string"
              },
              "hotWindowDays": {
                "minimum": 1,
                "type": "integer"
              },
              "priority": {
                "enum": [
                  "not_applicable",
                  "primary",
                  "cooling",
                  "validated",
                  "historical"
                ]
              },
              "profile": {
                "type": "string"
              },
              "reasonCode": {
                "type": "string"
              },
              "risk": {
                "type": "string"
              },
              "scope": {
                "items": {
                  "type": "string"
                },
                "type": "array"
              },
              "warmUntil": {
                "type": "string"
              },
              "warmWindowDays": {
                "minimum": 1,
                "type": "integer"
              }
            },
            "type": "object"
          },
          "telemetrySchemaVersion": {
            "type": "integer"
          },
          "tradingLogicCommit": {
            "type": [
              "boolean",
              "null"
            ]
          },
          "tradingLogicPaths": {
            "items": {
              "type": "string"
            },
            "type": "array"
          }
        },
        "type": "object"
      },
      "retention": {
        "properties": {
          "maxAgeDays": {
            "const": 14
          },
          "maxTraces": {
            "const": 200
          },
          "rollupAgeDays": {
            "const": 90
          }
        },
        "required": [
          "maxTraces",
          "maxAgeDays",
          "rollupAgeDays"
        ],
        "type": "object"
      },
      "schemaVersion": {
        "const": 3
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "serviceStatus": {
        "enum": [
          "running",
          "degraded",
          "unavailable"
        ]
      },
      "state": {
        "enum": [
          "collecting",
          "healthy",
          "regressed",
          "insufficient_data"
        ]
      },
      "traces": {
        "items": {
          "properties": {
            "latency": {
              "properties": {
                "attemptCount": {
                  "minimum": 0,
                  "type": [
                    "integer",
                    "null"
                  ]
                },
                "bybitTransportMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "internalDurationMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "latencyMeasurementVersion": {
                  "type": [
                    "integer",
                    "null"
                  ]
                },
                "localQueueMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "operationCount": {
                  "minimum": 0,
                  "type": [
                    "integer",
                    "null"
                  ]
                },
                "quality": {
                  "enum": [
                    "complete",
                    "partial",
                    "unavailable"
                  ]
                },
                "reason": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "responseProcessingMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "retryCount": {
                  "minimum": 0,
                  "type": [
                    "integer",
                    "null"
                  ]
                },
                "retryWaitMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "totalDurationMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "transportSumMs": {
                  "minimum": 0,
                  "type": [
                    "number",
                    "null"
                  ]
                }
              },
              "required": [
                "latencyMeasurementVersion",
                "quality",
                "reason",
                "totalDurationMs",
                "bybitTransportMs",
                "internalDurationMs"
              ],
              "type": "object"
            },
            "source": {
              "properties": {
                "botId": {
                  "type": "string"
                },
                "component": {
                  "type": "string"
                },
                "marketType": {
                  "type": "string"
                },
                "requestCorrelationId": {
                  "type": "string"
                },
                "sampleCount": {
                  "minimum": 0,
                  "type": "integer"
                },
                "uiRoute": {
                  "type": "string"
                }
              },
              "type": "object"
            }
          },
          "type": "object"
        },
        "maxItems": 200,
        "type": "array"
      }
    },
    "required": [
      "schemaVersion",
      "botId",
      "botType",
      "available",
      "retention",
      "serviceStatus",
      "droppedEvents",
      "release",
      "filters",
      "baseline",
      "state",
      "metrics",
      "outcomeMetrics",
      "comparison",
      "traces",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "bot_position_response": {
    "definitions": {
      "position": {
        "properties": {
          "entry_price": {
            "type": [
              "string",
              "number"
            ]
          },
          "roi": {
            "type": [
              "string",
              "number",
              "null"
            ]
          },
          "size": {
            "type": [
              "string",
              "number"
            ]
          },
          "symbol": {
            "type": "string"
          }
        },
        "type": "object"
      }
    },
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "current_capital": {
        "type": [
          "string",
          "number",
          "null"
        ]
      },
      "initial_deposit": {
        "type": [
          "string",
          "number",
          "null"
        ]
      },
      "next_candle_check_seconds": {
        "type": [
          "integer",
          "number",
          "null"
        ]
      },
      "position": {
        "anyOf": [
          {
            "$ref": "#/definitions/position"
          },
          {
            "type": "null"
          }
        ]
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "source": {
        "type": "string"
      },
      "success": {
        "type": "boolean"
      }
    },
    "required": [
      "success",
      "position",
      "source",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "bot_trades_response": {
    "anyOf": [
      {
        "required": [
          "deals"
        ]
      },
      {
        "required": [
          "cycles"
        ]
      }
    ],
    "definitions": {
      "trade": {
        "properties": {
          "deal_id": {
            "type": "string"
          },
          "display": {
            "properties": {
              "buy": {
                "properties": {
                  "has_order": {
                    "type": "boolean"
                  },
                  "placeholder": {
                    "type": "string"
                  },
                  "show_duration": {
                    "type": "boolean"
                  }
                },
                "required": [
                  "has_order",
                  "placeholder",
                  "show_duration"
                ],
                "type": "object"
              },
              "entry_side": {
                "enum": [
                  "LONG",
                  "SHORT"
                ]
              },
              "sell": {
                "properties": {
                  "has_order": {
                    "type": "boolean"
                  },
                  "placeholder": {
                    "type": "string"
                  },
                  "show_duration": {
                    "type": "boolean"
                  }
                },
                "required": [
                  "has_order",
                  "placeholder",
                  "show_duration"
                ],
                "type": "object"
              }
            },
            "required": [
              "entry_side",
              "sell",
              "buy"
            ],
            "type": "object"
          },
          "net_profit": {
            "type": [
              "string",
              "number",
              "null"
            ]
          },
          "start_time": {
            "type": [
              "string",
              "number",
              "null"
            ]
          }
        },
        "type": "object"
      }
    },
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "cycles": {
        "items": {
          "properties": {
            "display": {
              "properties": {
                "orders": {
                  "items": {
                    "properties": {
                      "display": {
                        "properties": {
                          "current_price": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "execution_basis": {
                            "enum": [
                              "ordered",
                              "remaining",
                              "filled"
                            ]
                          },
                          "filled_price": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "filled_quantity": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "filled_value": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "planned_price": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "price": {
                            "properties": {
                              "filled": {
                                "type": [
                                  "string",
                                  "number",
                                  "null"
                                ]
                              },
                              "manual": {
                                "type": [
                                  "string",
                                  "number",
                                  "null"
                                ]
                              },
                              "manual_primary": {
                                "type": "boolean"
                              },
                              "planned": {
                                "type": [
                                  "string",
                                  "number",
                                  "null"
                                ]
                              },
                              "precision": {
                                "maximum": 18,
                                "minimum": 0,
                                "type": "integer"
                              },
                              "primary": {
                                "type": [
                                  "string",
                                  "number",
                                  "null"
                                ]
                              }
                            },
                            "required": [
                              "primary",
                              "manual",
                              "planned",
                              "filled",
                              "manual_primary",
                              "precision"
                            ],
                            "type": "object"
                          },
                          "quantity": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "value": {
                            "type": [
                              "string",
                              "number",
                              "null"
                            ]
                          },
                          "value_note": {
                            "type": "string"
                          }
                        },
                        "type": "object"
                      }
                    },
                    "type": "object"
                  },
                  "type": "array"
                }
              },
              "type": "object"
            }
          },
          "type": "object"
        },
        "type": "array"
      },
      "deals": {
        "items": {
          "$ref": "#/definitions/trade"
        },
        "type": "array"
      },
      "historyType": {
        "type": "string"
      },
      "historyUnavailable": {
        "type": "boolean"
      },
      "metrics": {
        "type": "object"
      },
      "nextCursor": {
        "type": [
          "string",
          "null"
        ]
      },
      "pagination": {
        "properties": {
          "page": {
            "minimum": 1,
            "type": "integer"
          },
          "pageSize": {
            "minimum": 1,
            "type": "integer"
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "page",
          "pageSize",
          "total"
        ],
        "type": "object"
      },
      "purchases": {
        "items": {
          "type": "object"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      },
      "summary": {
        "type": "object"
      }
    },
    "required": [
      "success",
      "metrics",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "collection_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "items": {
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "items",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "combined_trade_journal_calendar_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "available_years": {
            "items": {
              "type": "integer"
            },
            "type": "array"
          },
          "days": {
            "items": {
              "properties": {
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "months": {
            "items": {
              "properties": {
                "month": {
                  "type": "integer"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "month",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "trade_count": {
            "type": "integer"
          },
          "year": {
            "type": "integer"
          },
          "year_net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          }
        },
        "required": [
          "year",
          "year_net_pnl",
          "trade_count",
          "available_years",
          "months",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "combined_trade_journal_day_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "bot_trade_count": {
            "type": "integer"
          },
          "bots": {
            "items": {
              "properties": {
                "bot_deleted_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_id": {
                  "type": "string"
                },
                "bot_name": {
                  "type": "string"
                },
                "bot_type": {
                  "type": "string"
                },
                "market_type": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "pair": {
                  "type": "string"
                },
                "trade_count": {
                  "minimum": 0,
                  "type": "integer"
                },
                "trade_type": {
                  "type": "string"
                },
                "trades": {
                  "items": {
                    "properties": {
                      "api_key_id": {
                        "type": "string"
                      },
                      "api_key_name": {
                        "type": "string"
                      },
                      "bot_deleted_at": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "bot_id": {
                        "type": "string"
                      },
                      "bot_name": {
                        "type": "string"
                      },
                      "bot_type": {
                        "type": "string"
                      },
                      "calculation_version": {
                        "type": "integer"
                      },
                      "close_reason": {
                        "type": "string"
                      },
                      "closed_at_utc": {
                        "type": "string"
                      },
                      "duration_minutes": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "entry_order": {
                        "properties": {
                          "filled_value": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "order_id": {
                            "type": "string"
                          },
                          "price": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "quantity": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "side": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "order_id",
                          "side",
                          "price",
                          "quantity",
                          "filled_value"
                        ],
                        "type": "object"
                      },
                      "exit_order": {
                        "properties": {
                          "filled_value": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "order_id": {
                            "type": "string"
                          },
                          "price": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "quantity": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "side": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "order_id",
                          "side",
                          "price",
                          "quantity",
                          "filled_value"
                        ],
                        "type": "object"
                      },
                      "fees": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "gross_pnl": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "local_date": {
                        "type": "string"
                      },
                      "market_type": {
                        "type": "string"
                      },
                      "net_pnl": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "opened_at_utc": {
                        "type": "string"
                      },
                      "pair": {
                        "type": "string"
                      },
                      "quote_currency": {
                        "const": "USDT"
                      },
                      "schema_version": {
                        "type": "integer"
                      },
                      "source": {
                        "enum": [
                          "dca",
                          "strategy"
                        ]
                      },
                      "timezone_at_close": {
                        "type": "string"
                      },
                      "trade_id": {
                        "type": "string"
                      },
                      "trade_type": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "trade_id",
                      "bot_id",
                      "bot_name",
                      "bot_type",
                      "market_type",
                      "trade_type",
                      "pair",
                      "quote_currency",
                      "opened_at_utc",
                      "closed_at_utc",
                      "local_date",
                      "entry_order",
                      "exit_order",
                      "gross_pnl",
                      "fees",
                      "net_pnl",
                      "duration_minutes",
                      "close_reason",
                      "source",
                      "calculation_version",
                      "schema_version"
                    ],
                    "type": "object"
                  },
                  "type": "array"
                }
              },
              "required": [
                "bot_id",
                "bot_name",
                "bot_type",
                "market_type",
                "trade_type",
                "pair",
                "trade_count",
                "net_pnl",
                "trades"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "date": {
            "type": "string"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "personal_trade_count": {
            "type": "integer"
          },
          "personal_trades": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "attributed_bot_id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "attribution_status": {
                  "type": "string"
                },
                "category": {
                  "type": "string"
                },
                "closed_at_utc": {
                  "type": "string"
                },
                "entry_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "exchange_order_id": {
                  "type": "string"
                },
                "exit_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "fees": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "gross_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "local_date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "personal_trade_id": {
                  "type": "string"
                },
                "quantity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "side": {
                  "type": "string"
                },
                "symbol": {
                  "type": "string"
                },
                "timezone": {
                  "type": "string"
                }
              },
              "required": [
                "personal_trade_id",
                "api_key_id",
                "api_key_name",
                "symbol",
                "category",
                "side",
                "quantity",
                "entry_price",
                "exit_price",
                "gross_pnl",
                "fees",
                "net_pnl",
                "closed_at_utc",
                "local_date"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "trade_count": {
            "type": "integer"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "date",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "bot_trade_count",
          "personal_trade_count",
          "bots",
          "personal_trades"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "combined_trade_journal_month_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "days": {
            "items": {
              "properties": {
                "bot_trade_count": {
                  "type": "integer"
                },
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "personal_trade_count": {
                  "type": "integer"
                },
                "trade_count": {
                  "type": "integer"
                },
                "win_rate_percent": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "winning_trade_count": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count",
                "winning_trade_count",
                "win_rate_percent",
                "bot_trade_count",
                "personal_trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "month": {
            "type": "integer"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "trade_count": {
            "type": "integer"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          },
          "year": {
            "type": "integer"
          }
        },
        "required": [
          "year",
          "month",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "dca_cycle_budget_request": {
    "properties": {
      "apiKeyName": {
        "minLength": 1,
        "type": "string"
      },
      "cycleAllocationPercent": {
        "type": [
          "string",
          "number"
        ]
      },
      "leverage": {
        "type": [
          "string",
          "number"
        ]
      },
      "marketType": {
        "enum": [
          "linear",
          "spot"
        ]
      }
    },
    "required": [
      "apiKeyName",
      "marketType",
      "cycleAllocationPercent",
      "leverage"
    ],
    "type": "object"
  },
  "dca_cycle_budget_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "preview": {
        "properties": {
          "availableBalance": {
            "type": "string"
          },
          "cycleAllocationPercent": {
            "type": "string"
          },
          "cycleBudget": {
            "type": "string"
          },
          "leverage": {
            "type": "string"
          },
          "marketType": {
            "enum": [
              "linear",
              "spot"
            ]
          },
          "maximumNotional": {
            "type": "string"
          }
        },
        "required": [
          "availableBalance",
          "cycleAllocationPercent",
          "cycleBudget",
          "maximumNotional",
          "leverage",
          "marketType"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "preview",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "dca_preview_request": {
    "properties": {
      "basic": {
        "properties": {
          "botType": {
            "const": "dca"
          }
        },
        "required": [
          "botType"
        ],
        "type": "object"
      },
      "dca": {
        "properties": {
          "mode": {
            "enum": [
              "signal",
              "alert_averaging",
              "accumulation"
            ]
          },
          "priceModel": {
            "type": "object"
          },
          "volumeModel": {
            "type": "object"
          }
        },
        "required": [
          "mode"
        ],
        "type": "object"
      }
    },
    "required": [
      "basic",
      "dca"
    ],
    "type": "object"
  },
  "dca_preview_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "preview": {
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "preview",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "deployment_artifacts_response": {
    "additionalProperties": false,
    "properties": {
      "active_sha": {
        "pattern": "^[0-9a-f]{40}$",
        "type": "string"
      },
      "api_version": {
        "const": "1"
      },
      "deploying": {
        "type": "boolean"
      },
      "format_version": {
        "const": 1
      },
      "generated_at": {
        "format": "date-time",
        "type": "string"
      },
      "schema_version": {
        "const": "1"
      },
      "target_sha": {
        "pattern": "^[0-9a-f]{40}$",
        "type": "string"
      }
    },
    "required": [
      "api_version",
      "schema_version",
      "format_version",
      "active_sha",
      "target_sha",
      "deploying",
      "generated_at"
    ],
    "type": "object"
  },
  "disk_refresh_response": {
    "properties": {
      "accepted": {
        "const": true
      },
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "refresh_requested": {
        "type": "boolean"
      },
      "refreshing": {
        "type": "boolean"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "snapshot": {
        "properties": {
          "calculation_version": {
            "type": "string"
          },
          "categories": {
            "items": {
              "properties": {
                "available": {
                  "type": "boolean"
                },
                "error": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "key": {
                  "type": "string"
                },
                "label": {
                  "type": "string"
                },
                "percent_of_used": {
                  "minimum": 0,
                  "type": "number"
                },
                "size_bytes": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "key",
                "label",
                "size_bytes",
                "available",
                "percent_of_used"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "hostname": {
            "type": "string"
          },
          "root": {
            "type": "object"
          },
          "snapshot_at": {
            "type": "string"
          },
          "storage_metadata": {
            "type": "object"
          }
        },
        "type": [
          "object",
          "null"
        ]
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "accepted",
      "refreshing",
      "refresh_requested",
      "snapshot",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "home_news_feed": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "frozenAt": {
        "type": [
          "string",
          "null"
        ]
      },
      "hasMore": {
        "type": "boolean"
      },
      "items": {
        "items": {
          "type": "object"
        },
        "type": "array"
      },
      "nextCursor": {
        "type": [
          "string",
          "null"
        ]
      },
      "refreshEnabled": {
        "type": "boolean"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "items",
      "hasMore",
      "nextCursor",
      "refreshEnabled",
      "frozenAt",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "home_news_settings": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "frozenAt": {
        "type": [
          "string",
          "null"
        ]
      },
      "refreshEnabled": {
        "type": "boolean"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "refreshEnabled",
      "frozenAt",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "journal_dashboard_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "accounts": {
            "items": {
              "properties": {
                "deleted": {
                  "type": "boolean"
                },
                "id": {
                  "type": "string"
                },
                "name": {
                  "type": "string"
                }
              },
              "required": [
                "id",
                "name",
                "deleted"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "availability": {
            "properties": {
              "balance": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              },
              "trades": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              }
            },
            "required": [
              "trades",
              "balance"
            ],
            "type": "object"
          },
          "balance": {
            "properties": {
              "currency": {
                "const": "USD"
              },
              "equity": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "points": {
                "items": {
                  "properties": {
                    "at": {
                      "type": "string"
                    },
                    "covered_accounts": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "equity": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "expected_accounts": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "stale": {
                      "type": "boolean"
                    }
                  },
                  "required": [
                    "at",
                    "equity",
                    "covered_accounts",
                    "expected_accounts",
                    "stale"
                  ],
                  "type": "object"
                },
                "type": "array"
              },
              "snapshot_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "state": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              }
            },
            "required": [
              "state",
              "currency",
              "equity",
              "snapshot_at",
              "points"
            ],
            "type": "object"
          },
          "currency": {
            "const": "USDT"
          },
          "filters": {
            "properties": {
              "api_key_id": {
                "type": "string"
              },
              "direction": {
                "enum": [
                  "all",
                  "long",
                  "short",
                  "spot"
                ]
              },
              "from": {
                "type": "string"
              },
              "source": {
                "enum": [
                  "all",
                  "bots",
                  "personal"
                ]
              },
              "symbol": {
                "type": "string"
              },
              "timezone": {
                "type": "string"
              },
              "to": {
                "type": "string"
              },
              "today": {
                "type": "string"
              }
            },
            "required": [
              "from",
              "to",
              "source",
              "api_key_id",
              "symbol",
              "direction",
              "timezone",
              "today"
            ],
            "type": "object"
          },
          "report": {
            "properties": {
              "average_loss": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "average_ratio": {
                "properties": {
                  "state": {
                    "enum": [
                      "available",
                      "unavailable",
                      "infinite"
                    ]
                  },
                  "value": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "state",
                  "value"
                ],
                "type": "object"
              },
              "average_share": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "average_win": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "calendar": {
                "properties": {
                  "from": {
                    "type": "string"
                  },
                  "months": {
                    "additionalProperties": {
                      "properties": {
                        "flat": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "losses": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "net_pnl": {
                          "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "state": {
                          "enum": [
                            "available",
                            "unavailable",
                            "empty",
                            "incomplete",
                            "stale",
                            "error",
                            "disabled"
                          ]
                        },
                        "trades": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "trading_days": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "weeks": {
                          "items": {
                            "properties": {
                              "flat": {
                                "minimum": 0,
                                "type": "integer"
                              },
                              "losses": {
                                "minimum": 0,
                                "type": "integer"
                              },
                              "net_pnl": {
                                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                                "type": [
                                  "string",
                                  "null"
                                ]
                              },
                              "state": {
                                "enum": [
                                  "available",
                                  "unavailable",
                                  "empty",
                                  "incomplete",
                                  "stale",
                                  "error",
                                  "disabled"
                                ]
                              },
                              "trades": {
                                "minimum": 0,
                                "type": "integer"
                              },
                              "trading_days": {
                                "minimum": 0,
                                "type": "integer"
                              },
                              "win_rate": {
                                "properties": {
                                  "state": {
                                    "enum": [
                                      "available",
                                      "unavailable",
                                      "infinite"
                                    ]
                                  },
                                  "value": {
                                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                                    "type": [
                                      "string",
                                      "null"
                                    ]
                                  }
                                },
                                "required": [
                                  "state",
                                  "value"
                                ],
                                "type": "object"
                              },
                              "wins": {
                                "minimum": 0,
                                "type": "integer"
                              }
                            },
                            "required": [
                              "state",
                              "net_pnl",
                              "trades",
                              "wins",
                              "losses",
                              "flat",
                              "win_rate",
                              "trading_days"
                            ],
                            "type": "object"
                          },
                          "type": "array"
                        },
                        "win_rate": {
                          "properties": {
                            "state": {
                              "enum": [
                                "available",
                                "unavailable",
                                "infinite"
                              ]
                            },
                            "value": {
                              "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "required": [
                            "state",
                            "value"
                          ],
                          "type": "object"
                        },
                        "wins": {
                          "minimum": 0,
                          "type": "integer"
                        }
                      },
                      "required": [
                        "state",
                        "net_pnl",
                        "trades",
                        "wins",
                        "losses",
                        "flat",
                        "win_rate",
                        "trading_days",
                        "weeks"
                      ],
                      "type": "object"
                    },
                    "type": "object"
                  },
                  "to": {
                    "type": "string"
                  },
                  "years": {
                    "additionalProperties": {
                      "properties": {
                        "flat": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "losses": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "net_pnl": {
                          "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "state": {
                          "enum": [
                            "available",
                            "unavailable",
                            "empty",
                            "incomplete",
                            "stale",
                            "error",
                            "disabled"
                          ]
                        },
                        "trades": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "trading_days": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "win_rate": {
                          "properties": {
                            "state": {
                              "enum": [
                                "available",
                                "unavailable",
                                "infinite"
                              ]
                            },
                            "value": {
                              "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "required": [
                            "state",
                            "value"
                          ],
                          "type": "object"
                        },
                        "wins": {
                          "minimum": 0,
                          "type": "integer"
                        }
                      },
                      "required": [
                        "state",
                        "net_pnl",
                        "trades",
                        "wins",
                        "losses",
                        "flat",
                        "win_rate",
                        "trading_days"
                      ],
                      "type": "object"
                    },
                    "type": "object"
                  }
                },
                "required": [
                  "from",
                  "to",
                  "months",
                  "years"
                ],
                "type": "object"
              },
              "cumulative": {
                "items": {
                  "properties": {
                    "date": {
                      "type": "string"
                    },
                    "net_pnl": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    }
                  },
                  "required": [
                    "date",
                    "net_pnl"
                  ],
                  "type": "object"
                },
                "type": "array"
              },
              "daily": {
                "items": {
                  "properties": {
                    "date": {
                      "type": "string"
                    },
                    "flat": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "losses": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "net_pnl": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "state": {
                      "enum": [
                        "available",
                        "unavailable",
                        "empty",
                        "incomplete",
                        "stale",
                        "error",
                        "disabled"
                      ]
                    },
                    "trades": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "win_rate": {
                      "properties": {
                        "state": {
                          "enum": [
                            "available",
                            "unavailable",
                            "infinite"
                          ]
                        },
                        "value": {
                          "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                          "type": [
                            "string",
                            "null"
                          ]
                        }
                      },
                      "required": [
                        "state",
                        "value"
                      ],
                      "type": "object"
                    },
                    "wins": {
                      "minimum": 0,
                      "type": "integer"
                    }
                  },
                  "required": [
                    "state",
                    "net_pnl",
                    "trades",
                    "wins",
                    "losses",
                    "flat",
                    "win_rate",
                    "date"
                  ],
                  "type": "object"
                },
                "type": "array"
              },
              "day_results": {
                "properties": {
                  "flat": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "losses": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "net_pnl": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "state": {
                    "enum": [
                      "available",
                      "unavailable",
                      "empty",
                      "incomplete",
                      "stale",
                      "error",
                      "disabled"
                    ]
                  },
                  "trades": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "win_rate": {
                    "properties": {
                      "state": {
                        "enum": [
                          "available",
                          "unavailable",
                          "infinite"
                        ]
                      },
                      "value": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "required": [
                      "state",
                      "value"
                    ],
                    "type": "object"
                  },
                  "wins": {
                    "minimum": 0,
                    "type": "integer"
                  }
                },
                "required": [
                  "state",
                  "net_pnl",
                  "trades",
                  "wins",
                  "losses",
                  "flat",
                  "win_rate"
                ],
                "type": "object"
              },
              "flat": {
                "minimum": 0,
                "type": "integer"
              },
              "losses": {
                "minimum": 0,
                "type": "integer"
              },
              "net_pnl": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "profit_factor": {
                "properties": {
                  "state": {
                    "enum": [
                      "available",
                      "unavailable",
                      "infinite"
                    ]
                  },
                  "value": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "state",
                  "value"
                ],
                "type": "object"
              },
              "profit_share": {
                "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                "type": [
                  "string",
                  "null"
                ]
              },
              "state": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              },
              "trades": {
                "minimum": 0,
                "type": "integer"
              },
              "win_rate": {
                "properties": {
                  "state": {
                    "enum": [
                      "available",
                      "unavailable",
                      "infinite"
                    ]
                  },
                  "value": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "state",
                  "value"
                ],
                "type": "object"
              },
              "wins": {
                "minimum": 0,
                "type": "integer"
              }
            },
            "required": [
              "state",
              "net_pnl",
              "trades",
              "wins",
              "losses",
              "flat",
              "win_rate",
              "profit_factor",
              "average_win",
              "average_loss",
              "average_ratio",
              "day_results",
              "daily",
              "cumulative",
              "calendar",
              "profit_share",
              "average_share"
            ],
            "type": "object"
          },
          "symbols": {
            "items": {
              "type": "string"
            },
            "type": "array"
          },
          "sync": {
            "properties": {
              "interval": {
                "enum": [
                  "off",
                  "1m",
                  "5m",
                  "1h",
                  "1d"
                ]
              },
              "last_success_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "state": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              },
              "states": {
                "items": {
                  "type": "object"
                },
                "type": "array"
              }
            },
            "required": [
              "interval",
              "state",
              "last_success_at",
              "states"
            ],
            "type": "object"
          }
        },
        "required": [
          "filters",
          "accounts",
          "symbols",
          "currency",
          "report",
          "balance",
          "sync",
          "availability"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "journal_positions_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "accounts": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "deleted": {
                  "type": "boolean"
                },
                "name": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "snapshot_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "state": {
                  "enum": [
                    "available",
                    "unavailable",
                    "empty",
                    "incomplete",
                    "stale",
                    "error",
                    "disabled"
                  ]
                }
              },
              "required": [
                "api_key_id",
                "snapshot_at",
                "state"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "currency": {
            "const": "USDT"
          },
          "items": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_name": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "currency": {
                  "const": "USDT"
                },
                "direction": {
                  "type": "string"
                },
                "entry_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "id": {
                  "type": "string"
                },
                "leverage": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "margin_mode": {
                  "enum": [
                    "cross",
                    "isolated",
                    "portfolio",
                    null
                  ]
                },
                "mark_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "position_idx": {
                  "minimum": 0,
                  "type": "integer"
                },
                "quantity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "snapshot_at": {
                  "type": "string"
                },
                "source": {
                  "enum": [
                    "bots",
                    "personal",
                    "unclassified"
                  ]
                },
                "stale": {
                  "type": "boolean"
                },
                "symbol": {
                  "type": "string"
                },
                "unrealised_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "updated_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              },
              "required": [
                "id",
                "api_key_id",
                "symbol",
                "direction",
                "position_idx",
                "source",
                "bot_id",
                "quantity",
                "entry_price",
                "mark_price",
                "unrealised_pnl",
                "currency",
                "updated_at",
                "snapshot_at",
                "stale"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "state": {
            "enum": [
              "available",
              "unavailable",
              "empty",
              "incomplete",
              "stale",
              "error",
              "disabled"
            ]
          },
          "sync": {
            "properties": {
              "interval": {
                "enum": [
                  "off",
                  "1m",
                  "5m",
                  "1h",
                  "1d"
                ]
              },
              "last_success_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "state": {
                "enum": [
                  "available",
                  "unavailable",
                  "empty",
                  "incomplete",
                  "stale",
                  "error",
                  "disabled"
                ]
              },
              "states": {
                "items": {
                  "type": "object"
                },
                "type": "array"
              }
            },
            "required": [
              "interval",
              "state",
              "last_success_at",
              "states"
            ],
            "type": "object"
          }
        },
        "required": [
          "items",
          "accounts",
          "currency",
          "state",
          "sync"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "journal_trades_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "currency": {
            "const": "USDT"
          },
          "filters": {
            "properties": {
              "api_key_id": {
                "type": "string"
              },
              "direction": {
                "enum": [
                  "all",
                  "long",
                  "short",
                  "spot"
                ]
              },
              "from": {
                "type": "string"
              },
              "source": {
                "enum": [
                  "all",
                  "bots",
                  "personal"
                ]
              },
              "symbol": {
                "type": "string"
              },
              "timezone": {
                "type": "string"
              },
              "to": {
                "type": "string"
              },
              "today": {
                "type": "string"
              }
            },
            "required": [
              "from",
              "to",
              "source",
              "api_key_id",
              "symbol",
              "direction",
              "timezone",
              "today"
            ],
            "type": "object"
          },
          "items": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "attribution_status": {
                  "type": "string"
                },
                "bot_deleted_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_name": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_type": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "close_reason": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "closed_at_utc": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "currency": {
                  "const": "USDT"
                },
                "direction": {
                  "type": "string"
                },
                "duration_minutes": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "entry_order": {
                  "properties": {
                    "filled_value": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "price": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "quantity": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    }
                  },
                  "required": [],
                  "type": "object"
                },
                "entry_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "exchange_order_id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "exit_order": {
                  "properties": {
                    "filled_value": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "price": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "quantity": {
                      "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                      "type": [
                        "string",
                        "null"
                      ]
                    }
                  },
                  "required": [],
                  "type": "object"
                },
                "exit_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "fees": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "gross_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "history_source": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "id": {
                  "type": "string"
                },
                "local_date": {
                  "type": "string"
                },
                "market_type": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "opened_at_utc": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "quantity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "source": {
                  "enum": [
                    "bots",
                    "personal"
                  ]
                },
                "symbol": {
                  "type": "string"
                },
                "timezone_at_close": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "trade_id": {
                  "type": "string"
                }
              },
              "required": [
                "id",
                "trade_id",
                "source",
                "api_key_id",
                "api_key_name",
                "bot_id",
                "bot_name",
                "bot_type",
                "bot_deleted_at",
                "symbol",
                "direction",
                "local_date",
                "timezone_at_close",
                "closed_at_utc",
                "opened_at_utc",
                "net_pnl",
                "fees",
                "gross_pnl",
                "entry_price",
                "exit_price",
                "quantity",
                "entry_order",
                "exit_order",
                "exchange_order_id",
                "duration_minutes",
                "close_reason",
                "attribution_status",
                "currency",
                "market_type",
                "history_source"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "next_cursor": {
            "type": [
              "string",
              "null"
            ]
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "items",
          "total",
          "next_cursor",
          "currency",
          "filters"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "log_window_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "cursor": {
        "maxLength": 4096,
        "type": "string"
      },
      "logs": {
        "type": "string"
      },
      "mode": {
        "enum": [
          "reset",
          "append"
        ],
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "window": {
        "properties": {
          "currentFileOnly": {
            "type": "boolean"
          },
          "lineLimitReached": {
            "type": "boolean"
          },
          "maxBytes": {
            "type": "integer"
          },
          "maxLines": {
            "type": "integer"
          },
          "newestAvailableAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "oldestAvailableAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "truncated": {
            "type": "boolean"
          }
        },
        "required": [
          "maxBytes",
          "maxLines",
          "truncated",
          "lineLimitReached",
          "currentFileOnly"
        ],
        "type": "object"
      }
    },
    "required": [
      "logs",
      "window",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "openai_usage_snapshots_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "pagination": {
        "properties": {
          "page": {
            "minimum": 1,
            "type": "integer"
          },
          "pageSize": {
            "enum": [
              10,
              20,
              50,
              100
            ]
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "page",
          "pageSize",
          "total"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "snapshots": {
        "items": {
          "properties": {
            "dailyBudgetUsd": {
              "minimum": 0,
              "type": "number"
            },
            "generatedAt": {
              "type": "string"
            },
            "localDate": {
              "type": "string"
            },
            "periodEnd": {
              "type": "string"
            },
            "periodStart": {
              "type": "string"
            },
            "remainingDailyBudgetUsd": {
              "minimum": 0,
              "type": "number"
            },
            "timezone": {
              "type": "string"
            },
            "totals": {
              "properties": {
                "blocked": {
                  "minimum": 0,
                  "type": "integer"
                },
                "cacheHitRate": {
                  "maximum": 1,
                  "minimum": 0,
                  "type": "number"
                },
                "cacheHits": {
                  "minimum": 0,
                  "type": "integer"
                },
                "cachedInputTokens": {
                  "minimum": 0,
                  "type": "integer"
                },
                "estimatedCostUsd": {
                  "minimum": 0,
                  "type": "number"
                },
                "failures": {
                  "minimum": 0,
                  "type": "integer"
                },
                "inputTokens": {
                  "minimum": 0,
                  "type": "integer"
                },
                "outputTokens": {
                  "minimum": 0,
                  "type": "integer"
                },
                "providerRequests": {
                  "minimum": 0,
                  "type": "integer"
                },
                "requests": {
                  "minimum": 0,
                  "type": "integer"
                },
                "successes": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "requests",
                "providerRequests",
                "cacheHits",
                "successes",
                "failures",
                "blocked",
                "inputTokens",
                "cachedInputTokens",
                "outputTokens",
                "estimatedCostUsd",
                "cacheHitRate"
              ],
              "type": "object"
            }
          },
          "required": [
            "timezone",
            "localDate",
            "periodStart",
            "periodEnd",
            "totals",
            "dailyBudgetUsd",
            "remainingDailyBudgetUsd",
            "generatedAt"
          ],
          "type": "object"
        },
        "type": "array"
      }
    },
    "required": [
      "snapshots",
      "pagination",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "order_preview_request": {
    "properties": {
      "min_notional_value": {
        "type": [
          "string",
          "number"
        ]
      },
      "min_order_qty": {
        "type": [
          "string",
          "number"
        ]
      },
      "order_value": {
        "type": [
          "string",
          "number"
        ]
      },
      "price": {
        "type": [
          "string",
          "number"
        ]
      },
      "qty_step": {
        "type": [
          "string",
          "number"
        ]
      }
    },
    "required": [
      "order_value",
      "price"
    ],
    "type": "object"
  },
  "order_preview_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "notional": {
            "type": "string"
          },
          "price": {
            "type": "string"
          },
          "quantity": {
            "type": "string"
          }
        },
        "required": [
          "quantity",
          "notional",
          "price"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "performance_regression_ack_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "regression": {
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "regression",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "performance_regressions_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "regressions": {
        "items": {
          "properties": {
            "acknowledged": {
              "type": "boolean"
            },
            "assessment": {
              "properties": {
                "band": {
                  "enum": [
                    "good",
                    "attention",
                    "bad",
                    "unknown"
                  ]
                },
                "confirmations": {
                  "minimum": 0,
                  "type": "integer"
                },
                "deltaMs": {
                  "type": "number"
                },
                "deltaPercent": {
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "reasonCode": {
                  "type": "string"
                },
                "regressionThresholdMs": {
                  "type": "number"
                },
                "requiredConfirmations": {
                  "const": 3
                },
                "requiredSampleCount": {
                  "const": 20
                },
                "sampleCount": {
                  "minimum": 0,
                  "type": "integer"
                },
                "warningThresholdMs": {
                  "type": "number"
                }
              },
              "type": "object"
            },
            "confirmations": {
              "minimum": 0,
              "type": "integer"
            },
            "currentDeploymentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "currentLatencyAttribution": {
              "properties": {
                "components": {
                  "items": {
                    "properties": {
                      "currentP95Ms": {
                        "type": "number"
                      },
                      "deltaMs": {
                        "type": "number"
                      },
                      "metric": {
                        "type": "string"
                      },
                      "previousP95Ms": {
                        "type": "number"
                      }
                    },
                    "required": [
                      "metric",
                      "previousP95Ms",
                      "currentP95Ms",
                      "deltaMs"
                    ],
                    "type": "object"
                  },
                  "type": "array"
                },
                "currentWindow": {
                  "properties": {
                    "completeCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "latencyMeasurementVersion": {
                      "type": [
                        "integer",
                        "null"
                      ]
                    },
                    "periodEnd": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "periodStart": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "sampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "totalSampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "workload": {
                      "type": "object"
                    }
                  },
                  "required": [
                    "sampleCount",
                    "completeCount",
                    "totalSampleCount"
                  ],
                  "type": "object"
                },
                "largestIncrease": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "previousWindow": {
                  "properties": {
                    "completeCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "latencyMeasurementVersion": {
                      "type": [
                        "integer",
                        "null"
                      ]
                    },
                    "periodEnd": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "periodStart": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "sampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "totalSampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "workload": {
                      "type": "object"
                    }
                  },
                  "required": [
                    "sampleCount",
                    "completeCount",
                    "totalSampleCount"
                  ],
                  "type": "object"
                },
                "reason": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "slowTraces": {
                  "items": {
                    "properties": {
                      "latency": {
                        "properties": {
                          "attemptCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "bybitTransportMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "internalDurationMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "latencyMeasurementVersion": {
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "localQueueMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "operationCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "quality": {
                            "enum": [
                              "complete",
                              "partial",
                              "unavailable"
                            ]
                          },
                          "reason": {
                            "type": [
                              "string",
                              "null"
                            ]
                          },
                          "responseProcessingMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "retryCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "retryWaitMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "totalDurationMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "transportSumMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          }
                        },
                        "required": [
                          "latencyMeasurementVersion",
                          "quality",
                          "reason",
                          "totalDurationMs",
                          "bybitTransportMs",
                          "internalDurationMs"
                        ],
                        "type": "object"
                      },
                      "startedAt": {
                        "type": "string"
                      },
                      "traceId": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "traceId",
                      "startedAt",
                      "latency"
                    ],
                    "type": "object"
                  },
                  "maxItems": 5,
                  "type": "array"
                },
                "status": {
                  "enum": [
                    "measured",
                    "unavailable"
                  ]
                }
              },
              "required": [
                "status",
                "reason",
                "largestIncrease",
                "components",
                "currentWindow",
                "previousWindow",
                "slowTraces"
              ],
              "type": "object"
            },
            "deltaMs": {
              "type": "number"
            },
            "deltaPercent": {
              "type": [
                "number",
                "null"
              ]
            },
            "explanationCode": {
              "type": "string"
            },
            "isCurrentRelease": {
              "type": "boolean"
            },
            "latencyAttribution": {
              "properties": {
                "components": {
                  "items": {
                    "properties": {
                      "currentP95Ms": {
                        "type": "number"
                      },
                      "deltaMs": {
                        "type": "number"
                      },
                      "metric": {
                        "type": "string"
                      },
                      "previousP95Ms": {
                        "type": "number"
                      }
                    },
                    "required": [
                      "metric",
                      "previousP95Ms",
                      "currentP95Ms",
                      "deltaMs"
                    ],
                    "type": "object"
                  },
                  "type": "array"
                },
                "currentWindow": {
                  "properties": {
                    "completeCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "latencyMeasurementVersion": {
                      "type": [
                        "integer",
                        "null"
                      ]
                    },
                    "periodEnd": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "periodStart": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "sampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "totalSampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "workload": {
                      "type": "object"
                    }
                  },
                  "required": [
                    "sampleCount",
                    "completeCount",
                    "totalSampleCount"
                  ],
                  "type": "object"
                },
                "largestIncrease": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "previousWindow": {
                  "properties": {
                    "completeCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "latencyMeasurementVersion": {
                      "type": [
                        "integer",
                        "null"
                      ]
                    },
                    "periodEnd": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "periodStart": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "sampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "totalSampleCount": {
                      "minimum": 0,
                      "type": "integer"
                    },
                    "workload": {
                      "type": "object"
                    }
                  },
                  "required": [
                    "sampleCount",
                    "completeCount",
                    "totalSampleCount"
                  ],
                  "type": "object"
                },
                "reason": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "slowTraces": {
                  "items": {
                    "properties": {
                      "latency": {
                        "properties": {
                          "attemptCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "bybitTransportMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "internalDurationMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "latencyMeasurementVersion": {
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "localQueueMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "operationCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "quality": {
                            "enum": [
                              "complete",
                              "partial",
                              "unavailable"
                            ]
                          },
                          "reason": {
                            "type": [
                              "string",
                              "null"
                            ]
                          },
                          "responseProcessingMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "retryCount": {
                            "minimum": 0,
                            "type": [
                              "integer",
                              "null"
                            ]
                          },
                          "retryWaitMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "totalDurationMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          },
                          "transportSumMs": {
                            "minimum": 0,
                            "type": [
                              "number",
                              "null"
                            ]
                          }
                        },
                        "required": [
                          "latencyMeasurementVersion",
                          "quality",
                          "reason",
                          "totalDurationMs",
                          "bybitTransportMs",
                          "internalDurationMs"
                        ],
                        "type": "object"
                      },
                      "startedAt": {
                        "type": "string"
                      },
                      "traceId": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "traceId",
                      "startedAt",
                      "latency"
                    ],
                    "type": "object"
                  },
                  "maxItems": 5,
                  "type": "array"
                },
                "status": {
                  "enum": [
                    "measured",
                    "unavailable"
                  ]
                }
              },
              "required": [
                "status",
                "reason",
                "largestIncrease",
                "components",
                "currentWindow",
                "previousWindow",
                "slowTraces"
              ],
              "type": "object"
            },
            "lifecycleState": {
              "enum": [
                "active",
                "verifying",
                "resolved",
                "historical"
              ]
            },
            "notificationSnapshot": {
              "properties": {
                "latencyAttribution": {
                  "properties": {
                    "components": {
                      "items": {
                        "properties": {
                          "currentP95Ms": {
                            "type": "number"
                          },
                          "deltaMs": {
                            "type": "number"
                          },
                          "metric": {
                            "type": "string"
                          },
                          "previousP95Ms": {
                            "type": "number"
                          }
                        },
                        "required": [
                          "metric",
                          "previousP95Ms",
                          "currentP95Ms",
                          "deltaMs"
                        ],
                        "type": "object"
                      },
                      "type": "array"
                    },
                    "currentWindow": {
                      "properties": {
                        "completeCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "latencyMeasurementVersion": {
                          "type": [
                            "integer",
                            "null"
                          ]
                        },
                        "periodEnd": {
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "periodStart": {
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "sampleCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "totalSampleCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "workload": {
                          "type": "object"
                        }
                      },
                      "required": [
                        "sampleCount",
                        "completeCount",
                        "totalSampleCount"
                      ],
                      "type": "object"
                    },
                    "largestIncrease": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "previousWindow": {
                      "properties": {
                        "completeCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "latencyMeasurementVersion": {
                          "type": [
                            "integer",
                            "null"
                          ]
                        },
                        "periodEnd": {
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "periodStart": {
                          "type": [
                            "string",
                            "null"
                          ]
                        },
                        "sampleCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "totalSampleCount": {
                          "minimum": 0,
                          "type": "integer"
                        },
                        "workload": {
                          "type": "object"
                        }
                      },
                      "required": [
                        "sampleCount",
                        "completeCount",
                        "totalSampleCount"
                      ],
                      "type": "object"
                    },
                    "reason": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "slowTraces": {
                      "items": {
                        "properties": {
                          "latency": {
                            "properties": {
                              "attemptCount": {
                                "minimum": 0,
                                "type": [
                                  "integer",
                                  "null"
                                ]
                              },
                              "bybitTransportMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "internalDurationMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "latencyMeasurementVersion": {
                                "type": [
                                  "integer",
                                  "null"
                                ]
                              },
                              "localQueueMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "operationCount": {
                                "minimum": 0,
                                "type": [
                                  "integer",
                                  "null"
                                ]
                              },
                              "quality": {
                                "enum": [
                                  "complete",
                                  "partial",
                                  "unavailable"
                                ]
                              },
                              "reason": {
                                "type": [
                                  "string",
                                  "null"
                                ]
                              },
                              "responseProcessingMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "retryCount": {
                                "minimum": 0,
                                "type": [
                                  "integer",
                                  "null"
                                ]
                              },
                              "retryWaitMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "totalDurationMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              },
                              "transportSumMs": {
                                "minimum": 0,
                                "type": [
                                  "number",
                                  "null"
                                ]
                              }
                            },
                            "required": [
                              "latencyMeasurementVersion",
                              "quality",
                              "reason",
                              "totalDurationMs",
                              "bybitTransportMs",
                              "internalDurationMs"
                            ],
                            "type": "object"
                          },
                          "startedAt": {
                            "type": "string"
                          },
                          "traceId": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "traceId",
                          "startedAt",
                          "latency"
                        ],
                        "type": "object"
                      },
                      "maxItems": 5,
                      "type": "array"
                    },
                    "status": {
                      "enum": [
                        "measured",
                        "unavailable"
                      ]
                    }
                  },
                  "required": [
                    "status",
                    "reason",
                    "largestIncrease",
                    "components",
                    "currentWindow",
                    "previousWindow",
                    "slowTraces"
                  ],
                  "type": "object"
                }
              },
              "type": [
                "object",
                "null"
              ]
            },
            "reasonCode": {
              "type": "string"
            },
            "regressionThresholdMs": {
              "type": "number"
            },
            "requiredConfirmations": {
              "const": 3
            },
            "requiredSampleCount": {
              "const": 20
            },
            "resolvedByDeploymentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "sampleCount": {
              "minimum": 0,
              "type": "integer"
            },
            "source": {
              "properties": {
                "botId": {
                  "type": "string"
                },
                "component": {
                  "type": "string"
                },
                "marketType": {
                  "type": "string"
                },
                "requestCorrelationId": {
                  "type": "string"
                },
                "sampleCount": {
                  "minimum": 0,
                  "type": "integer"
                },
                "uiRoute": {
                  "type": "string"
                }
              },
              "type": "object"
            },
            "verifiedAt": {
              "type": [
                "string",
                "null"
              ]
            },
            "verifiedByDeploymentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "warningThresholdMs": {
              "type": "number"
            }
          },
          "type": "object"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "regressions",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "performance_releases_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "pagination": {
        "properties": {
          "page": {
            "minimum": 1,
            "type": "integer"
          },
          "pageSize": {
            "maximum": 100,
            "minimum": 1,
            "type": "integer"
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "page",
          "pageSize",
          "total"
        ],
        "type": "object"
      },
      "releases": {
        "items": {
          "properties": {
            "deploymentId": {
              "type": "string"
            },
            "isCurrentRelease": {
              "type": "boolean"
            },
            "latencyWindows": {
              "items": {
                "properties": {
                  "completeCount": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "latencyMeasurementVersion": {
                    "type": [
                      "integer",
                      "null"
                    ]
                  },
                  "periodEnd": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "periodStart": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "sampleCount": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "totalSampleCount": {
                    "minimum": 0,
                    "type": "integer"
                  },
                  "workload": {
                    "type": "object"
                  }
                },
                "required": [
                  "sampleCount",
                  "completeCount",
                  "totalSampleCount"
                ],
                "type": "object"
              },
              "type": "array"
            },
            "postEntry": {
              "type": "object"
            },
            "postEntryComparison": {
              "type": "object"
            },
            "regressionAttribution": {
              "properties": {
                "ageDays": {
                  "type": [
                    "number",
                    "null"
                  ]
                },
                "healthySampleCount": {
                  "minimum": 0,
                  "type": "integer"
                },
                "healthySampleTarget": {
                  "minimum": 1,
                  "type": "integer"
                },
                "hotUntil": {
                  "type": "string"
                },
                "hotWindowDays": {
                  "minimum": 1,
                  "type": "integer"
                },
                "priority": {
                  "enum": [
                    "not_applicable",
                    "primary",
                    "cooling",
                    "validated",
                    "historical"
                  ]
                },
                "profile": {
                  "type": "string"
                },
                "reasonCode": {
                  "type": "string"
                },
                "risk": {
                  "type": "string"
                },
                "scope": {
                  "items": {
                    "type": "string"
                  },
                  "type": "array"
                },
                "warmUntil": {
                  "type": "string"
                },
                "warmWindowDays": {
                  "minimum": 1,
                  "type": "integer"
                }
              },
              "type": "object"
            },
            "status": {
              "enum": [
                "observing",
                "baseline_ready",
                "healthy",
                "regressed",
                "resolved",
                "insufficient_data",
                "had_regression"
              ]
            }
          },
          "type": "object"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "releases",
      "pagination",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "performance_trace_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "trace": {
        "properties": {
          "latency": {
            "properties": {
              "attemptCount": {
                "minimum": 0,
                "type": [
                  "integer",
                  "null"
                ]
              },
              "bybitTransportMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "internalDurationMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "latencyMeasurementVersion": {
                "type": [
                  "integer",
                  "null"
                ]
              },
              "localQueueMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "operationCount": {
                "minimum": 0,
                "type": [
                  "integer",
                  "null"
                ]
              },
              "quality": {
                "enum": [
                  "complete",
                  "partial",
                  "unavailable"
                ]
              },
              "reason": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "responseProcessingMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "retryCount": {
                "minimum": 0,
                "type": [
                  "integer",
                  "null"
                ]
              },
              "retryWaitMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "totalDurationMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              },
              "transportSumMs": {
                "minimum": 0,
                "type": [
                  "number",
                  "null"
                ]
              }
            },
            "required": [
              "latencyMeasurementVersion",
              "quality",
              "reason",
              "totalDurationMs",
              "bybitTransportMs",
              "internalDurationMs"
            ],
            "type": "object"
          }
        },
        "required": [
          "traceId",
          "latency"
        ],
        "type": "object"
      }
    },
    "required": [
      "trace",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_balance_history_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "api_key_id": {
            "type": "string"
          },
          "from": {
            "type": "string"
          },
          "points": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "available_balance": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "calculation_version": {
                  "type": "integer"
                },
                "currency": {
                  "type": "string"
                },
                "snapshot_at": {
                  "type": "string"
                },
                "source": {
                  "type": "string"
                },
                "total_equity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "unrealised_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "wallet_balance": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                }
              },
              "required": [
                "api_key_id",
                "api_key_name",
                "total_equity",
                "wallet_balance",
                "available_balance",
                "unrealised_pnl",
                "currency",
                "snapshot_at"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "to": {
            "type": "string"
          }
        },
        "required": [
          "api_key_id",
          "from",
          "to",
          "points"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_calendar_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "available_years": {
            "items": {
              "type": "integer"
            },
            "type": "array"
          },
          "days": {
            "items": {
              "properties": {
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "months": {
            "items": {
              "properties": {
                "month": {
                  "type": "integer"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "month",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "trade_count": {
            "type": "integer"
          },
          "year": {
            "type": "integer"
          },
          "year_net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          }
        },
        "required": [
          "year",
          "year_net_pnl",
          "trade_count",
          "available_years",
          "months",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_day_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "date": {
            "type": "string"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "trade_count": {
            "type": "integer"
          },
          "trades": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "attributed_bot_id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "attribution_status": {
                  "type": "string"
                },
                "category": {
                  "type": "string"
                },
                "closed_at_utc": {
                  "type": "string"
                },
                "entry_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "exchange_order_id": {
                  "type": "string"
                },
                "exit_price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "fees": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "gross_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "local_date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "personal_trade_id": {
                  "type": "string"
                },
                "quantity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "side": {
                  "type": "string"
                },
                "symbol": {
                  "type": "string"
                },
                "timezone": {
                  "type": "string"
                }
              },
              "required": [
                "personal_trade_id",
                "api_key_id",
                "api_key_name",
                "symbol",
                "category",
                "side",
                "quantity",
                "entry_price",
                "exit_price",
                "gross_pnl",
                "fees",
                "net_pnl",
                "closed_at_utc",
                "local_date"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "date",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "trades"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_keys_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "keys": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "deleted_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "last_error": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "last_success_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "next_sync_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "sync_status": {
                  "type": "string"
                }
              },
              "required": [
                "api_key_id",
                "api_key_name"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "sync": {
            "properties": {
              "enabled": {
                "type": "boolean"
              },
              "interval": {
                "enum": [
                  "off",
                  "1m",
                  "5m",
                  "1h",
                  "1d"
                ]
              },
              "last_counts": {
                "type": [
                  "object",
                  "null"
                ]
              },
              "last_error": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "last_success_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "next_sync_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "options": {
                "items": {
                  "enum": [
                    "off",
                    "1m",
                    "5m",
                    "1h",
                    "1d"
                  ]
                },
                "type": "array"
              },
              "sync_status": {
                "type": [
                  "string",
                  "null"
                ]
              }
            },
            "required": [
              "interval",
              "options",
              "enabled"
            ],
            "type": "object"
          }
        },
        "required": [
          "keys",
          "sync"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_month_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "days": {
            "items": {
              "properties": {
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                },
                "win_rate_percent": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "winning_trade_count": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count",
                "winning_trade_count",
                "win_rate_percent"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "month": {
            "type": "integer"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "trade_count": {
            "type": "integer"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          },
          "year": {
            "type": "integer"
          }
        },
        "required": [
          "year",
          "month",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_resolve_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "bot_id": {
            "type": [
              "string",
              "null"
            ]
          },
          "execution_id": {
            "type": "string"
          },
          "resolved": {
            "const": true
          },
          "target": {
            "enum": [
              "personal",
              "bot"
            ]
          }
        },
        "required": [
          "resolved",
          "execution_id",
          "target",
          "bot_id"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_summary_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "api_key_id": {
            "type": "string"
          },
          "api_key_name": {
            "type": "string"
          },
          "balance": {
            "anyOf": [
              {
                "properties": {
                  "api_key_id": {
                    "type": "string"
                  },
                  "api_key_name": {
                    "type": "string"
                  },
                  "available_balance": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": "string"
                  },
                  "calculation_version": {
                    "type": "integer"
                  },
                  "currency": {
                    "type": "string"
                  },
                  "snapshot_at": {
                    "type": "string"
                  },
                  "source": {
                    "type": "string"
                  },
                  "total_equity": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": "string"
                  },
                  "unrealised_pnl": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": "string"
                  },
                  "wallet_balance": {
                    "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                    "type": "string"
                  }
                },
                "required": [
                  "api_key_id",
                  "api_key_name",
                  "total_equity",
                  "wallet_balance",
                  "available_balance",
                  "unrealised_pnl",
                  "currency",
                  "snapshot_at"
                ],
                "type": "object"
              },
              {
                "type": "null"
              }
            ]
          },
          "deleted_at": {
            "type": [
              "string",
              "null"
            ]
          },
          "spot_history_supported": {
            "const": false
          },
          "sync": {
            "properties": {
              "enabled": {
                "type": "boolean"
              },
              "interval": {
                "enum": [
                  "off",
                  "1m",
                  "5m",
                  "1h",
                  "1d"
                ]
              },
              "last_counts": {
                "type": [
                  "object",
                  "null"
                ]
              },
              "last_error": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "last_success_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "next_sync_at": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "options": {
                "items": {
                  "enum": [
                    "off",
                    "1m",
                    "5m",
                    "1h",
                    "1d"
                  ]
                },
                "type": "array"
              },
              "sync_status": {
                "type": [
                  "string",
                  "null"
                ]
              }
            },
            "required": [
              "interval",
              "options",
              "enabled"
            ],
            "type": "object"
          }
        },
        "required": [
          "api_key_id",
          "api_key_name",
          "balance",
          "sync",
          "spot_history_supported"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_sync_settings_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "enabled": {
            "type": "boolean"
          },
          "interval": {
            "enum": [
              "off",
              "1m",
              "5m",
              "1h",
              "1d"
            ]
          },
          "last_counts": {
            "type": [
              "object",
              "null"
            ]
          },
          "last_error": {
            "type": [
              "string",
              "null"
            ]
          },
          "last_success_at": {
            "type": [
              "string",
              "null"
            ]
          },
          "next_sync_at": {
            "type": [
              "string",
              "null"
            ]
          },
          "options": {
            "items": {
              "enum": [
                "off",
                "1m",
                "5m",
                "1h",
                "1d"
              ]
            },
            "type": "array"
          },
          "sync_status": {
            "type": [
              "string",
              "null"
            ]
          }
        },
        "required": [
          "interval",
          "options",
          "enabled"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "personal_trading_unclassified_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "bots": {
            "items": {
              "properties": {
                "id": {
                  "type": "string"
                },
                "name": {
                  "type": "string"
                }
              },
              "required": [
                "id",
                "name"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "items": {
            "items": {
              "properties": {
                "api_key_id": {
                  "type": "string"
                },
                "api_key_name": {
                  "type": "string"
                },
                "attribution_status": {
                  "const": "unclassified"
                },
                "exchange_execution_id": {
                  "type": "string"
                },
                "executed_at": {
                  "type": "string"
                },
                "fee": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "price": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "quantity": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "side": {
                  "type": "string"
                },
                "symbol": {
                  "type": "string"
                }
              },
              "required": [
                "exchange_execution_id",
                "api_key_id",
                "api_key_name",
                "symbol",
                "side",
                "price",
                "quantity",
                "fee",
                "executed_at",
                "attribution_status"
              ],
              "type": "object"
            },
            "type": "array"
          }
        },
        "required": [
          "items",
          "bots"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "position": {
    "properties": {
      "entry_price": {
        "type": [
          "string",
          "number"
        ]
      },
      "roi": {
        "type": [
          "string",
          "number",
          "null"
        ]
      },
      "size": {
        "type": [
          "string",
          "number"
        ]
      },
      "symbol": {
        "type": "string"
      }
    },
    "type": "object"
  },
  "positions_response": {
    "definitions": {
      "position": {
        "properties": {
          "entry_price": {
            "type": [
              "string",
              "number"
            ]
          },
          "roi": {
            "type": [
              "string",
              "number",
              "null"
            ]
          },
          "size": {
            "type": [
              "string",
              "number"
            ]
          },
          "symbol": {
            "type": "string"
          }
        },
        "type": "object"
      }
    },
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "positions": {
        "items": {
          "$ref": "#/definitions/position"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "positions",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "runtime_action_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "duration_ms": {
        "minimum": 0,
        "type": [
          "integer",
          "null"
        ]
      },
      "lifecycle_updated_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "lifecycle_version": {
        "minimum": 0,
        "type": "integer"
      },
      "message": {
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "started_at": {
        "type": [
          "integer",
          "null"
        ]
      },
      "status": {
        "type": "string"
      },
      "stopped_at": {
        "type": [
          "integer",
          "null"
        ]
      }
    },
    "required": [
      "status",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "runtime_status": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "bot_id": {
        "type": "string"
      },
      "confirmed_status": {
        "type": [
          "string",
          "null"
        ]
      },
      "duration_ms": {
        "minimum": 0,
        "type": [
          "integer",
          "null"
        ]
      },
      "lifecycle_updated_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "lifecycle_version": {
        "minimum": 0,
        "type": "integer"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "started_at": {
        "type": [
          "integer",
          "string",
          "null"
        ]
      },
      "status": {
        "type": "string"
      },
      "stopped_at": {
        "type": [
          "integer",
          "null"
        ]
      },
      "updated_at": {
        "type": "string"
      }
    },
    "required": [
      "status",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "runtime_summaries_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "summaries": {
        "additionalProperties": {
          "properties": {
            "dca_runtime": {
              "type": "object"
            },
            "found": {
              "type": "boolean"
            },
            "position_snapshot": {
              "type": [
                "object",
                "null"
              ]
            },
            "runtime_state": {
              "type": "object"
            },
            "safety": {
              "properties": {
                "blockedReason": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "exposureBlocked": {
                  "type": "boolean"
                },
                "lastSafetyCheckAt": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "liquidationDistancePercent": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "liquidationPrice": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "liquidationPriceStatus": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "markPrice": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "positionMonitoring": {
                  "type": "boolean"
                },
                "protectionStatus": {
                  "type": "string"
                },
                "safetyState": {
                  "type": "string"
                },
                "workerHeartbeatAt": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              },
              "type": "object"
            },
            "simulation_snapshot_ready": {
              "type": "boolean"
            },
            "snapshot_version": {
              "type": [
                "integer",
                "string",
                "null"
              ]
            },
            "started_at": {
              "type": [
                "integer",
                "string",
                "null"
              ]
            },
            "status": {
              "type": "string"
            },
            "updated_at": {
              "type": [
                "string",
                "integer",
                "null"
              ]
            }
          },
          "required": [
            "status",
            "found"
          ],
          "type": "object"
        },
        "type": "object"
      }
    },
    "required": [
      "summaries",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "security_event_ack_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "event": {
        "properties": {
          "acknowledged_at": {
            "type": [
              "string",
              "null"
            ]
          },
          "acknowledged_by": {
            "type": [
              "string",
              "null"
            ]
          },
          "category": {
            "enum": [
              "ssh",
              "http",
              "cors",
              "auth",
              "websocket",
              "rate_limit",
              "admin",
              "system"
            ]
          },
          "count": {
            "minimum": 1,
            "type": "integer"
          },
          "details": {
            "type": "object"
          },
          "event_id": {
            "minLength": 1,
            "type": "string"
          },
          "event_type": {
            "minLength": 1,
            "type": "string"
          },
          "fingerprint": {
            "type": [
              "string",
              "null"
            ]
          },
          "first_seen": {
            "type": [
              "string",
              "null"
            ]
          },
          "host": {
            "type": [
              "string",
              "null"
            ]
          },
          "last_seen": {
            "type": [
              "string",
              "null"
            ]
          },
          "method": {
            "type": [
              "string",
              "null"
            ]
          },
          "origin": {
            "type": [
              "string",
              "null"
            ]
          },
          "path": {
            "type": [
              "string",
              "null"
            ]
          },
          "request_id": {
            "type": [
              "string",
              "null"
            ]
          },
          "severity": {
            "enum": [
              "info",
              "low",
              "medium",
              "high",
              "critical"
            ]
          },
          "source": {
            "enum": [
              "application",
              "nginx",
              "ssh",
              "firewall"
            ]
          },
          "source_ip": {
            "type": [
              "string",
              "null"
            ]
          },
          "status": {
            "enum": [
              "blocked",
              "observed",
              "allowed",
              "acknowledged"
            ]
          },
          "user_id": {
            "type": [
              "string",
              "null"
            ]
          }
        },
        "required": [
          "event_id",
          "source",
          "category",
          "event_type",
          "severity",
          "status",
          "count",
          "first_seen",
          "last_seen",
          "details"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "event",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "security_events_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "generated_at": {
        "type": "string"
      },
      "items": {
        "items": {
          "properties": {
            "categories": {
              "items": {
                "enum": [
                  "ssh",
                  "http",
                  "cors",
                  "auth",
                  "websocket",
                  "rate_limit",
                  "admin",
                  "system"
                ]
              },
              "type": "array"
            },
            "event_count": {
              "minimum": 1,
              "type": "integer"
            },
            "events": {
              "items": {
                "properties": {
                  "acknowledged_at": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "acknowledged_by": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "category": {
                    "enum": [
                      "ssh",
                      "http",
                      "cors",
                      "auth",
                      "websocket",
                      "rate_limit",
                      "admin",
                      "system"
                    ]
                  },
                  "count": {
                    "minimum": 1,
                    "type": "integer"
                  },
                  "details": {
                    "type": "object"
                  },
                  "event_id": {
                    "minLength": 1,
                    "type": "string"
                  },
                  "event_type": {
                    "minLength": 1,
                    "type": "string"
                  },
                  "fingerprint": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "first_seen": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "host": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "last_seen": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "method": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "origin": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "path": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "request_id": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "severity": {
                    "enum": [
                      "info",
                      "low",
                      "medium",
                      "high",
                      "critical"
                    ]
                  },
                  "source": {
                    "enum": [
                      "application",
                      "nginx",
                      "ssh",
                      "firewall"
                    ]
                  },
                  "source_ip": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "status": {
                    "enum": [
                      "blocked",
                      "observed",
                      "allowed",
                      "acknowledged"
                    ]
                  },
                  "user_id": {
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "event_id",
                  "source",
                  "category",
                  "event_type",
                  "severity",
                  "status",
                  "count",
                  "first_seen",
                  "last_seen",
                  "details"
                ],
                "type": "object"
              },
              "type": "array"
            },
            "first_seen": {
              "type": [
                "string",
                "null"
              ]
            },
            "group_key": {
              "minLength": 1,
              "type": "string"
            },
            "last_seen": {
              "type": [
                "string",
                "null"
              ]
            },
            "occurrences": {
              "minimum": 1,
              "type": "integer"
            },
            "severity": {
              "enum": [
                "info",
                "low",
                "medium",
                "high",
                "critical"
              ]
            },
            "source_ip": {
              "type": [
                "string",
                "null"
              ]
            },
            "sources": {
              "items": {
                "enum": [
                  "application",
                  "nginx",
                  "ssh",
                  "firewall"
                ]
              },
              "type": "array"
            },
            "status": {
              "enum": [
                "blocked",
                "observed",
                "acknowledged"
              ]
            }
          },
          "required": [
            "group_key",
            "source_ip",
            "sources",
            "categories",
            "severity",
            "status",
            "event_count",
            "occurrences",
            "first_seen",
            "last_seen",
            "events"
          ],
          "type": "object"
        },
        "type": "array"
      },
      "next_cursor": {
        "type": [
          "string",
          "null"
        ]
      },
      "pagination": {
        "properties": {
          "page": {
            "minimum": 1,
            "type": "integer"
          },
          "pageSize": {
            "minimum": 1,
            "type": "integer"
          },
          "total": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "page",
          "pageSize",
          "total"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "items",
      "next_cursor",
      "pagination",
      "generated_at",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "security_summary_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "blocked": {
            "minimum": 0,
            "type": "integer"
          },
          "by_category": {
            "type": "object"
          },
          "by_severity": {
            "type": "object"
          },
          "by_source": {
            "type": "object"
          },
          "critical": {
            "minimum": 0,
            "type": "integer"
          },
          "events": {
            "minimum": 0,
            "type": "integer"
          },
          "generated_at": {
            "type": "string"
          },
          "high": {
            "minimum": 0,
            "type": "integer"
          },
          "last_event": {
            "type": [
              "object",
              "null"
            ]
          },
          "occurrences": {
            "minimum": 0,
            "type": "integer"
          },
          "rate_limited": {
            "minimum": 0,
            "type": "integer"
          },
          "rejected": {
            "minimum": 0,
            "type": "integer"
          },
          "suspicious": {
            "minimum": 0,
            "type": "integer"
          },
          "window_seconds": {
            "minimum": 60,
            "type": "integer"
          }
        },
        "required": [
          "window_seconds",
          "events",
          "occurrences",
          "blocked",
          "rejected",
          "rate_limited",
          "suspicious",
          "high",
          "critical",
          "by_severity",
          "by_category",
          "by_source",
          "last_event",
          "generated_at"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "server_diagnostics_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "deployment": {
        "type": "object"
      },
      "deployment_status": {
        "properties": {
          "actionsCheckedAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "actionsCreatedAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "actionsRunId": {
            "type": [
              "integer",
              "null"
            ]
          },
          "actionsState": {
            "enum": [
              "unknown",
              "not_created",
              "queued",
              "in_progress",
              "success",
              "failure",
              "cancelled",
              "skipped"
            ]
          },
          "actionsUpdatedAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "actionsUrl": {
            "type": [
              "string",
              "null"
            ]
          },
          "currentSha": {
            "type": [
              "string",
              "null"
            ]
          },
          "error": {
            "type": [
              "string",
              "null"
            ]
          },
          "fallbackRequired": {
            "type": "boolean"
          },
          "stage": {
            "type": "string"
          },
          "startedAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "targetObservedAt": {
            "type": [
              "string",
              "null"
            ]
          },
          "targetSha": {
            "type": [
              "string",
              "null"
            ]
          },
          "updatedAt": {
            "type": [
              "string",
              "null"
            ]
          }
        },
        "type": "object"
      },
      "generated_at": {
        "type": "string"
      },
      "last_refresh_error": {
        "type": [
          "string",
          "null"
        ]
      },
      "next_refresh_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "refresh_requested": {
        "type": "boolean"
      },
      "refresh_requested_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "refresh_started_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "refreshing": {
        "type": "boolean"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "snapshot": {
        "properties": {
          "calculation_version": {
            "type": "string"
          },
          "categories": {
            "items": {
              "properties": {
                "available": {
                  "type": "boolean"
                },
                "error": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "key": {
                  "type": "string"
                },
                "label": {
                  "type": "string"
                },
                "percent_of_used": {
                  "minimum": 0,
                  "type": "number"
                },
                "size_bytes": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "key",
                "label",
                "size_bytes",
                "available",
                "percent_of_used"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "hostname": {
            "type": "string"
          },
          "root": {
            "type": "object"
          },
          "snapshot_at": {
            "type": "string"
          },
          "storage_metadata": {
            "type": "object"
          }
        },
        "type": [
          "object",
          "null"
        ]
      },
      "state": {
        "enum": [
          "loading",
          "cached",
          "refreshing",
          "stale",
          "unavailable"
        ]
      },
      "storage_alert": {
        "type": [
          "object",
          "null"
        ]
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "state",
      "snapshot",
      "refreshing",
      "refresh_requested",
      "generated_at",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "server_services_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "generated_at": {
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "services": {
        "items": {
          "properties": {
            "active_since": {
              "type": [
                "string",
                "null"
              ]
            },
            "active_state": {
              "type": "string"
            },
            "error": {
              "type": [
                "string",
                "null"
              ]
            },
            "identifier": {
              "type": "string"
            },
            "key": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "pid": {
              "type": [
                "integer",
                "null"
              ]
            },
            "status": {
              "enum": [
                "running",
                "degraded",
                "stopped",
                "failed",
                "unknown",
                "unavailable"
              ]
            },
            "sub_state": {
              "type": "string"
            },
            "telemetry": {
              "type": "object"
            },
            "uptime_seconds": {
              "type": [
                "integer",
                "null"
              ]
            }
          },
          "required": [
            "key",
            "name",
            "identifier",
            "status",
            "active_state",
            "sub_state"
          ],
          "type": "object"
        },
        "type": "array"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "services",
      "generated_at",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "stack_restart_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "error": {
        "type": "string"
      },
      "ok": {
        "type": "boolean"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "stderr": {
        "type": "string"
      },
      "stdout": {
        "type": "string"
      }
    },
    "required": [
      "ok",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trade": {
    "properties": {
      "deal_id": {
        "type": "string"
      },
      "display": {
        "properties": {
          "buy": {
            "properties": {
              "has_order": {
                "type": "boolean"
              },
              "placeholder": {
                "type": "string"
              },
              "show_duration": {
                "type": "boolean"
              }
            },
            "required": [
              "has_order",
              "placeholder",
              "show_duration"
            ],
            "type": "object"
          },
          "entry_side": {
            "enum": [
              "LONG",
              "SHORT"
            ]
          },
          "sell": {
            "properties": {
              "has_order": {
                "type": "boolean"
              },
              "placeholder": {
                "type": "string"
              },
              "show_duration": {
                "type": "boolean"
              }
            },
            "required": [
              "has_order",
              "placeholder",
              "show_duration"
            ],
            "type": "object"
          }
        },
        "required": [
          "entry_side",
          "sell",
          "buy"
        ],
        "type": "object"
      },
      "net_profit": {
        "type": [
          "string",
          "number",
          "null"
        ]
      },
      "start_time": {
        "type": [
          "string",
          "number",
          "null"
        ]
      }
    },
    "type": "object"
  },
  "trade_journal_calendar_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "available_years": {
            "items": {
              "type": "integer"
            },
            "type": "array"
          },
          "days": {
            "items": {
              "properties": {
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "months": {
            "items": {
              "properties": {
                "month": {
                  "type": "integer"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                }
              },
              "required": [
                "month",
                "net_pnl",
                "trade_count"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "trade_count": {
            "type": "integer"
          },
          "year": {
            "type": "integer"
          },
          "year_net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          }
        },
        "required": [
          "year",
          "year_net_pnl",
          "trade_count",
          "available_years",
          "months",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trade_journal_day_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "bots": {
            "items": {
              "properties": {
                "bot_deleted_at": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "bot_id": {
                  "type": "string"
                },
                "bot_name": {
                  "type": "string"
                },
                "bot_type": {
                  "type": "string"
                },
                "market_type": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "pair": {
                  "type": "string"
                },
                "trade_count": {
                  "minimum": 0,
                  "type": "integer"
                },
                "trade_type": {
                  "type": "string"
                },
                "trades": {
                  "items": {
                    "properties": {
                      "api_key_id": {
                        "type": "string"
                      },
                      "api_key_name": {
                        "type": "string"
                      },
                      "bot_deleted_at": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "bot_id": {
                        "type": "string"
                      },
                      "bot_name": {
                        "type": "string"
                      },
                      "bot_type": {
                        "type": "string"
                      },
                      "calculation_version": {
                        "type": "integer"
                      },
                      "close_reason": {
                        "type": "string"
                      },
                      "closed_at_utc": {
                        "type": "string"
                      },
                      "duration_minutes": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "entry_order": {
                        "properties": {
                          "filled_value": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "order_id": {
                            "type": "string"
                          },
                          "price": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "quantity": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "side": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "order_id",
                          "side",
                          "price",
                          "quantity",
                          "filled_value"
                        ],
                        "type": "object"
                      },
                      "exit_order": {
                        "properties": {
                          "filled_value": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "order_id": {
                            "type": "string"
                          },
                          "price": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "quantity": {
                            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                            "type": "string"
                          },
                          "side": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "order_id",
                          "side",
                          "price",
                          "quantity",
                          "filled_value"
                        ],
                        "type": "object"
                      },
                      "fees": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "gross_pnl": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "local_date": {
                        "type": "string"
                      },
                      "market_type": {
                        "type": "string"
                      },
                      "net_pnl": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "opened_at_utc": {
                        "type": "string"
                      },
                      "pair": {
                        "type": "string"
                      },
                      "quote_currency": {
                        "const": "USDT"
                      },
                      "schema_version": {
                        "type": "integer"
                      },
                      "source": {
                        "enum": [
                          "dca",
                          "strategy"
                        ]
                      },
                      "timezone_at_close": {
                        "type": "string"
                      },
                      "trade_id": {
                        "type": "string"
                      },
                      "trade_type": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "trade_id",
                      "bot_id",
                      "bot_name",
                      "bot_type",
                      "market_type",
                      "trade_type",
                      "pair",
                      "quote_currency",
                      "opened_at_utc",
                      "closed_at_utc",
                      "local_date",
                      "entry_order",
                      "exit_order",
                      "gross_pnl",
                      "fees",
                      "net_pnl",
                      "duration_minutes",
                      "close_reason",
                      "source",
                      "calculation_version",
                      "schema_version"
                    ],
                    "type": "object"
                  },
                  "type": "array"
                }
              },
              "required": [
                "bot_id",
                "bot_name",
                "bot_type",
                "market_type",
                "trade_type",
                "pair",
                "trade_count",
                "net_pnl",
                "trades"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "date": {
            "type": "string"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "trade_count": {
            "type": "integer"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          }
        },
        "required": [
          "date",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "bots"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trade_journal_month_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "days": {
            "items": {
              "properties": {
                "bots": {
                  "items": {
                    "properties": {
                      "bot_deleted_at": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "bot_id": {
                        "type": "string"
                      },
                      "bot_name": {
                        "type": "string"
                      },
                      "bot_type": {
                        "type": "string"
                      },
                      "market_type": {
                        "type": "string"
                      },
                      "net_pnl": {
                        "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                        "type": "string"
                      },
                      "pair": {
                        "type": "string"
                      },
                      "trade_count": {
                        "minimum": 0,
                        "type": "integer"
                      },
                      "trade_type": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "bot_id",
                      "bot_name",
                      "bot_type",
                      "market_type",
                      "trade_type",
                      "pair",
                      "trade_count",
                      "net_pnl"
                    ],
                    "type": "object"
                  },
                  "type": "array"
                },
                "date": {
                  "type": "string"
                },
                "net_pnl": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "trade_count": {
                  "type": "integer"
                },
                "win_rate_percent": {
                  "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
                  "type": "string"
                },
                "winning_trade_count": {
                  "minimum": 0,
                  "type": "integer"
                }
              },
              "required": [
                "date",
                "net_pnl",
                "trade_count",
                "winning_trade_count",
                "win_rate_percent",
                "bots"
              ],
              "type": "object"
            },
            "type": "array"
          },
          "month": {
            "type": "integer"
          },
          "net_pnl": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "trade_count": {
            "type": "integer"
          },
          "win_rate_percent": {
            "pattern": "^-?[0-9]+(?:\\.[0-9]+)?$",
            "type": "string"
          },
          "winning_trade_count": {
            "minimum": 0,
            "type": "integer"
          },
          "year": {
            "type": "integer"
          }
        },
        "required": [
          "year",
          "month",
          "net_pnl",
          "trade_count",
          "winning_trade_count",
          "win_rate_percent",
          "days"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trade_journal_test_data_response": {
    "properties": {
      "affected_count": {
        "minimum": 0,
        "type": "integer"
      },
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "affected_count",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trade_metrics_request": {
    "properties": {
      "trades": {
        "items": {
          "type": "object"
        },
        "type": "array"
      }
    },
    "required": [
      "trades"
    ],
    "type": "object"
  },
  "trade_metrics_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "data": {
        "properties": {
          "average_pnl": {
            "type": "string"
          },
          "groups": {
            "type": "object"
          },
          "loss_trades": {
            "minimum": 0,
            "type": "integer"
          },
          "profitable_trades": {
            "minimum": 0,
            "type": "integer"
          },
          "total_pnl": {
            "type": "string"
          },
          "total_trades": {
            "minimum": 0,
            "type": "integer"
          },
          "win_rate": {
            "type": "string"
          }
        },
        "required": [
          "total_trades",
          "profitable_trades",
          "loss_trades",
          "win_rate",
          "total_pnl",
          "average_pnl",
          "groups"
        ],
        "type": "object"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "success": {
        "const": true
      }
    },
    "required": [
      "success",
      "data",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "trades_response": {
    "definitions": {
      "trade": {
        "properties": {
          "deal_id": {
            "type": "string"
          },
          "display": {
            "properties": {
              "buy": {
                "properties": {
                  "has_order": {
                    "type": "boolean"
                  },
                  "placeholder": {
                    "type": "string"
                  },
                  "show_duration": {
                    "type": "boolean"
                  }
                },
                "required": [
                  "has_order",
                  "placeholder",
                  "show_duration"
                ],
                "type": "object"
              },
              "entry_side": {
                "enum": [
                  "LONG",
                  "SHORT"
                ]
              },
              "sell": {
                "properties": {
                  "has_order": {
                    "type": "boolean"
                  },
                  "placeholder": {
                    "type": "string"
                  },
                  "show_duration": {
                    "type": "boolean"
                  }
                },
                "required": [
                  "has_order",
                  "placeholder",
                  "show_duration"
                ],
                "type": "object"
              }
            },
            "required": [
              "entry_side",
              "sell",
              "buy"
            ],
            "type": "object"
          },
          "net_profit": {
            "type": [
              "string",
              "number",
              "null"
            ]
          },
          "start_time": {
            "type": [
              "string",
              "number",
              "null"
            ]
          }
        },
        "type": "object"
      }
    },
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "deals": {
        "items": {
          "$ref": "#/definitions/trade"
        },
        "type": "array"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "deals",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "versioned_response": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      }
    },
    "required": [
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "websocket_diagnostics": {
    "additionalProperties": false,
    "properties": {
      "ack_age_ms": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "attempts": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "browser_online": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "cause": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "client_release": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "close_code": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "confidence": {
        "enum": [
          "observed",
          "unknown"
        ]
      },
      "connection_id": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "consumer": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "diagnostic_version": {
        "const": 1
      },
      "dropped_records": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "duration_ms": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "incident_id": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "incoming_age_ms": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "initiator": {
        "enum": [
          "client",
          "server",
          "remote_or_transport"
        ]
      },
      "occurred_at": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "protocol": {
        "enum": [
          "ack_v2",
          "legacy"
        ]
      },
      "rtt_ms": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "sequence": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "server_connection_id": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "server_instance_id": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "server_release": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "sync_result": {
        "enum": [
          "succeeded",
          "failed"
        ]
      },
      "tab_id": {
        "maxLength": 128,
        "pattern": "^[a-zA-Z0-9_.:/ +\\-]*$",
        "type": [
          "string",
          "null"
        ]
      },
      "timer_lag_ms": {
        "maximum": 1000000000000.0,
        "minimum": 0,
        "type": [
          "number",
          "null"
        ]
      },
      "visibility": {
        "enum": [
          "visible",
          "hidden"
        ]
      },
      "was_clean": {
        "type": [
          "boolean",
          "null"
        ]
      }
    },
    "required": [
      "diagnostic_version",
      "cause",
      "confidence"
    ],
    "type": "object"
  },
  "websocket_event": {
    "properties": {
      "api_version": {
        "const": "1",
        "type": "string"
      },
      "bot_id": {
        "type": "string"
      },
      "duration_ms": {
        "minimum": 0,
        "type": [
          "integer",
          "null"
        ]
      },
      "lifecycle_updated_at": {
        "type": [
          "string",
          "null"
        ]
      },
      "lifecycle_version": {
        "minimum": 0,
        "type": "integer"
      },
      "schema_version": {
        "const": "1",
        "type": "string"
      },
      "started_at": {
        "type": [
          "integer",
          "null"
        ]
      },
      "stopped_at": {
        "type": [
          "integer",
          "null"
        ]
      },
      "timestamp": {
        "type": "string"
      },
      "type": {
        "type": "string"
      }
    },
    "required": [
      "type",
      "timestamp",
      "api_version",
      "schema_version"
    ],
    "type": "object"
  },
  "websocket_heartbeat_ack": {
    "properties": {
      "connection_id": {
        "maxLength": 80,
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9_-]+$",
        "type": "string"
      },
      "protocol_version": {
        "const": 2
      },
      "sequence": {
        "maximum": 9007199254740991,
        "minimum": 1,
        "type": "integer"
      },
      "server_connection_id": {
        "maxLength": 128,
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9_-]+$",
        "type": "string"
      },
      "server_instance_id": {
        "maxLength": 128,
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9_-]+$",
        "type": "string"
      },
      "server_release": {
        "maxLength": 128,
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9_-]+$",
        "type": "string"
      },
      "type": {
        "const": "heartbeat_ack"
      }
    },
    "required": [
      "type",
      "protocol_version",
      "sequence",
      "connection_id",
      "server_connection_id",
      "server_instance_id",
      "server_release"
    ],
    "type": "object"
  },
  "websocket_heartbeat_v2": {
    "additionalProperties": false,
    "properties": {
      "connection_id": {
        "maxLength": 80,
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9_-]+$",
        "type": "string"
      },
      "protocol_version": {
        "const": 2
      },
      "sequence": {
        "maximum": 9007199254740991,
        "minimum": 1,
        "type": "integer"
      },
      "type": {
        "const": "client_heartbeat"
      }
    },
    "required": [
      "type",
      "protocol_version",
      "sequence",
      "connection_id"
    ],
    "type": "object"
  }
})

function typeMatches(value, expected) {
  const types = Array.isArray(expected) ? expected : [expected]
  return types.some((type) => {
    if (type === 'null') return value === null
    if (type === 'array') return Array.isArray(value)
    if (type === 'object') return value !== null && typeof value === 'object' && !Array.isArray(value)
    if (type === 'integer') return Number.isInteger(value)
    return typeof value === type
  })
}

function resolveSchema(root, schema) {
  if (!schema?.$ref || !schema.$ref.startsWith('#/')) return schema
  return schema.$ref.slice(2).split('/').reduce((value, key) => value?.[key], root) || schema
}

function validateNode(root, schema, value, path, errors) {
  schema = resolveSchema(root, schema)
  if (!schema || typeof schema !== 'object') return
  if (schema.anyOf) {
    const matches = schema.anyOf.some((candidate) => {
      const candidateErrors = []
      validateNode(root, candidate, value, path, candidateErrors)
      return candidateErrors.length === 0
    })
    if (!matches) errors.push(`${path} does not match any allowed shape`)
  }
  if (schema.oneOf) {
    const matches = schema.oneOf.filter((candidate) => {
      const candidateErrors = []
      validateNode(root, candidate, value, path, candidateErrors)
      return candidateErrors.length === 0
    }).length
    if (matches !== 1) errors.push(`${path} must match exactly one allowed shape`)
  }
  if (schema.const !== undefined && value !== schema.const) errors.push(`${path} must equal ${JSON.stringify(schema.const)}`)
  if (schema.type && !typeMatches(value, schema.type)) { errors.push(`${path} has an invalid type`); return }
  if (schema.enum && !schema.enum.includes(value)) errors.push(`${path} must be one of ${schema.enum.join(', ')}`)
  if (typeof value === 'string' && schema.minLength !== undefined && value.length < schema.minLength) errors.push(`${path} is too short`)
  if (typeof value === 'number' && schema.minimum !== undefined && value < schema.minimum) errors.push(`${path} is below the minimum`)
  if (typeof value === 'number' && schema.maximum !== undefined && value > schema.maximum) errors.push(`${path} is above the maximum`)
  if (schema.required && value && typeof value === 'object') {
    for (const key of schema.required) if (!(key in value)) errors.push(`${path}.${key} is required`)
  }
  if (schema.properties && value && typeof value === 'object') {
    for (const [key, child] of Object.entries(schema.properties)) if (key in value) validateNode(root, child, value[key], `${path}.${key}`, errors)
    if (schema.additionalProperties === false) {
      for (const key of Object.keys(value)) if (!(key in schema.properties)) errors.push(`${path}.${key} is not allowed`)
    }
  }
  if (schema.items && Array.isArray(value)) value.forEach((item, index) => validateNode(root, schema.items, item, `${path}[${index}]`, errors))
}

export function validateContract(name, value) {
  const schema = CONTRACT_SCHEMAS[name]
  if (!schema) throw new Error(`Unknown API contract: ${name}`)
  const errors = []
  validateNode(schema, schema, value, '$', errors)
  return { valid: errors.length === 0, errors }
}

export class ContractError extends Error {
  constructor(message, code, details = {}) {
    super(message)
    this.name = 'ContractError'
    this.code = code
    this.status = 502
    this.details = details
    this.uiState = code === 'UNSUPPORTED_API_CONTRACT' ? 'unavailable' : 'runtime_error'
  }
}

export function assertVersioned(value, headers = null) {
  const receivedApi = value && !Array.isArray(value) ? value.api_version : headers?.get?.('X-API-Version')
  const receivedSchema = value && !Array.isArray(value) ? value.schema_version : headers?.get?.('X-Schema-Version')
  if (String(receivedApi) !== API_VERSION || String(receivedSchema) !== SCHEMA_VERSION) {
    throw new ContractError('API contract version is not supported', 'UNSUPPORTED_API_CONTRACT', { expectedApi: API_VERSION, expectedSchema: SCHEMA_VERSION, receivedApi, receivedSchema })
  }
  return value
}

export function parseContract(name, value) {
  const validation = validateContract(name, value)
  if (!validation.valid) throw new ContractError(`Invalid ${name} contract`, 'INVALID_API_CONTRACT', { errors: validation.errors })
  return value
}

/** @param {unknown} value @returns {ApiErrorDto} */
export function parseApiErrorDto(value) {
  return parseContract("api_error", value)
}

/** @param {unknown} value @returns {BotMutationRequestDto} */
export function parseBotMutationRequestDto(value) {
  return parseContract("bot_mutation_request", value)
}

/** @param {unknown} value @returns {BotMutationResponseDto} */
export function parseBotMutationResponseDto(value) {
  return parseContract("bot_mutation_response", value)
}

/** @param {unknown} value @returns {BotPerformanceHistoryResponseDto} */
export function parseBotPerformanceHistoryResponseDto(value) {
  return parseContract("bot_performance_history_response", value)
}

/** @param {unknown} value @returns {BotPerformanceResponseDto} */
export function parseBotPerformanceResponseDto(value) {
  return parseContract("bot_performance_response", value)
}

/** @param {unknown} value @returns {BotPositionResponseDto} */
export function parseBotPositionResponseDto(value) {
  return parseContract("bot_position_response", value)
}

/** @param {unknown} value @returns {BotTradesResponseDto} */
export function parseBotTradesResponseDto(value) {
  return parseContract("bot_trades_response", value)
}

/** @param {unknown} value @returns {CollectionResponseDto} */
export function parseCollectionResponseDto(value) {
  return parseContract("collection_response", value)
}

/** @param {unknown} value @returns {CombinedTradeJournalCalendarResponseDto} */
export function parseCombinedTradeJournalCalendarResponseDto(value) {
  return parseContract("combined_trade_journal_calendar_response", value)
}

/** @param {unknown} value @returns {CombinedTradeJournalDayResponseDto} */
export function parseCombinedTradeJournalDayResponseDto(value) {
  return parseContract("combined_trade_journal_day_response", value)
}

/** @param {unknown} value @returns {CombinedTradeJournalMonthResponseDto} */
export function parseCombinedTradeJournalMonthResponseDto(value) {
  return parseContract("combined_trade_journal_month_response", value)
}

/** @param {unknown} value @returns {DcaCycleBudgetRequestDto} */
export function parseDcaCycleBudgetRequestDto(value) {
  return parseContract("dca_cycle_budget_request", value)
}

/** @param {unknown} value @returns {DcaCycleBudgetResponseDto} */
export function parseDcaCycleBudgetResponseDto(value) {
  return parseContract("dca_cycle_budget_response", value)
}

/** @param {unknown} value @returns {DcaPreviewRequestDto} */
export function parseDcaPreviewRequestDto(value) {
  return parseContract("dca_preview_request", value)
}

/** @param {unknown} value @returns {DcaPreviewResponseDto} */
export function parseDcaPreviewResponseDto(value) {
  return parseContract("dca_preview_response", value)
}

/** @param {unknown} value @returns {DeploymentArtifactsResponseDto} */
export function parseDeploymentArtifactsResponseDto(value) {
  return parseContract("deployment_artifacts_response", value)
}

/** @param {unknown} value @returns {DiskRefreshResponseDto} */
export function parseDiskRefreshResponseDto(value) {
  return parseContract("disk_refresh_response", value)
}

/** @param {unknown} value @returns {HomeNewsFeedDto} */
export function parseHomeNewsFeedDto(value) {
  return parseContract("home_news_feed", value)
}

/** @param {unknown} value @returns {HomeNewsSettingsDto} */
export function parseHomeNewsSettingsDto(value) {
  return parseContract("home_news_settings", value)
}

/** @param {unknown} value @returns {JournalDashboardResponseDto} */
export function parseJournalDashboardResponseDto(value) {
  return parseContract("journal_dashboard_response", value)
}

/** @param {unknown} value @returns {JournalPositionsResponseDto} */
export function parseJournalPositionsResponseDto(value) {
  return parseContract("journal_positions_response", value)
}

/** @param {unknown} value @returns {JournalTradesResponseDto} */
export function parseJournalTradesResponseDto(value) {
  return parseContract("journal_trades_response", value)
}

/** @param {unknown} value @returns {LogWindowResponseDto} */
export function parseLogWindowResponseDto(value) {
  return parseContract("log_window_response", value)
}

/** @param {unknown} value @returns {OpenaiUsageSnapshotsResponseDto} */
export function parseOpenaiUsageSnapshotsResponseDto(value) {
  return parseContract("openai_usage_snapshots_response", value)
}

/** @param {unknown} value @returns {OrderPreviewRequestDto} */
export function parseOrderPreviewRequestDto(value) {
  return parseContract("order_preview_request", value)
}

/** @param {unknown} value @returns {OrderPreviewResponseDto} */
export function parseOrderPreviewResponseDto(value) {
  return parseContract("order_preview_response", value)
}

/** @param {unknown} value @returns {PerformanceRegressionAckResponseDto} */
export function parsePerformanceRegressionAckResponseDto(value) {
  return parseContract("performance_regression_ack_response", value)
}

/** @param {unknown} value @returns {PerformanceRegressionsResponseDto} */
export function parsePerformanceRegressionsResponseDto(value) {
  return parseContract("performance_regressions_response", value)
}

/** @param {unknown} value @returns {PerformanceReleasesResponseDto} */
export function parsePerformanceReleasesResponseDto(value) {
  return parseContract("performance_releases_response", value)
}

/** @param {unknown} value @returns {PerformanceTraceResponseDto} */
export function parsePerformanceTraceResponseDto(value) {
  return parseContract("performance_trace_response", value)
}

/** @param {unknown} value @returns {PersonalTradingBalanceHistoryResponseDto} */
export function parsePersonalTradingBalanceHistoryResponseDto(value) {
  return parseContract("personal_trading_balance_history_response", value)
}

/** @param {unknown} value @returns {PersonalTradingCalendarResponseDto} */
export function parsePersonalTradingCalendarResponseDto(value) {
  return parseContract("personal_trading_calendar_response", value)
}

/** @param {unknown} value @returns {PersonalTradingDayResponseDto} */
export function parsePersonalTradingDayResponseDto(value) {
  return parseContract("personal_trading_day_response", value)
}

/** @param {unknown} value @returns {PersonalTradingKeysResponseDto} */
export function parsePersonalTradingKeysResponseDto(value) {
  return parseContract("personal_trading_keys_response", value)
}

/** @param {unknown} value @returns {PersonalTradingMonthResponseDto} */
export function parsePersonalTradingMonthResponseDto(value) {
  return parseContract("personal_trading_month_response", value)
}

/** @param {unknown} value @returns {PersonalTradingResolveResponseDto} */
export function parsePersonalTradingResolveResponseDto(value) {
  return parseContract("personal_trading_resolve_response", value)
}

/** @param {unknown} value @returns {PersonalTradingSummaryResponseDto} */
export function parsePersonalTradingSummaryResponseDto(value) {
  return parseContract("personal_trading_summary_response", value)
}

/** @param {unknown} value @returns {PersonalTradingSyncSettingsResponseDto} */
export function parsePersonalTradingSyncSettingsResponseDto(value) {
  return parseContract("personal_trading_sync_settings_response", value)
}

/** @param {unknown} value @returns {PersonalTradingUnclassifiedResponseDto} */
export function parsePersonalTradingUnclassifiedResponseDto(value) {
  return parseContract("personal_trading_unclassified_response", value)
}

/** @param {unknown} value @returns {PositionDto} */
export function parsePositionDto(value) {
  return parseContract("position", value)
}

/** @param {unknown} value @returns {PositionsResponseDto} */
export function parsePositionsResponseDto(value) {
  return parseContract("positions_response", value)
}

/** @param {unknown} value @returns {RuntimeActionResponseDto} */
export function parseRuntimeActionResponseDto(value) {
  return parseContract("runtime_action_response", value)
}

/** @param {unknown} value @returns {RuntimeStatusDto} */
export function parseRuntimeStatusDto(value) {
  return parseContract("runtime_status", value)
}

/** @param {unknown} value @returns {RuntimeSummariesResponseDto} */
export function parseRuntimeSummariesResponseDto(value) {
  return parseContract("runtime_summaries_response", value)
}

/** @param {unknown} value @returns {SecurityEventAckResponseDto} */
export function parseSecurityEventAckResponseDto(value) {
  return parseContract("security_event_ack_response", value)
}

/** @param {unknown} value @returns {SecurityEventsResponseDto} */
export function parseSecurityEventsResponseDto(value) {
  return parseContract("security_events_response", value)
}

/** @param {unknown} value @returns {SecuritySummaryResponseDto} */
export function parseSecuritySummaryResponseDto(value) {
  return parseContract("security_summary_response", value)
}

/** @param {unknown} value @returns {ServerDiagnosticsResponseDto} */
export function parseServerDiagnosticsResponseDto(value) {
  return parseContract("server_diagnostics_response", value)
}

/** @param {unknown} value @returns {ServerServicesResponseDto} */
export function parseServerServicesResponseDto(value) {
  return parseContract("server_services_response", value)
}

/** @param {unknown} value @returns {StackRestartResponseDto} */
export function parseStackRestartResponseDto(value) {
  return parseContract("stack_restart_response", value)
}

/** @param {unknown} value @returns {TradeDto} */
export function parseTradeDto(value) {
  return parseContract("trade", value)
}

/** @param {unknown} value @returns {TradeJournalCalendarResponseDto} */
export function parseTradeJournalCalendarResponseDto(value) {
  return parseContract("trade_journal_calendar_response", value)
}

/** @param {unknown} value @returns {TradeJournalDayResponseDto} */
export function parseTradeJournalDayResponseDto(value) {
  return parseContract("trade_journal_day_response", value)
}

/** @param {unknown} value @returns {TradeJournalMonthResponseDto} */
export function parseTradeJournalMonthResponseDto(value) {
  return parseContract("trade_journal_month_response", value)
}

/** @param {unknown} value @returns {TradeJournalTestDataResponseDto} */
export function parseTradeJournalTestDataResponseDto(value) {
  return parseContract("trade_journal_test_data_response", value)
}

/** @param {unknown} value @returns {TradeMetricsRequestDto} */
export function parseTradeMetricsRequestDto(value) {
  return parseContract("trade_metrics_request", value)
}

/** @param {unknown} value @returns {TradeMetricsResponseDto} */
export function parseTradeMetricsResponseDto(value) {
  return parseContract("trade_metrics_response", value)
}

/** @param {unknown} value @returns {TradesResponseDto} */
export function parseTradesResponseDto(value) {
  return parseContract("trades_response", value)
}

/** @param {unknown} value @returns {VersionedResponseDto} */
export function parseVersionedResponseDto(value) {
  return parseContract("versioned_response", value)
}

/** @param {unknown} value @returns {WebsocketDiagnosticsDto} */
export function parseWebsocketDiagnosticsDto(value) {
  return parseContract("websocket_diagnostics", value)
}

/** @param {unknown} value @returns {WebsocketEventDto} */
export function parseWebsocketEventDto(value) {
  return parseContract("websocket_event", value)
}

/** @param {unknown} value @returns {WebsocketHeartbeatAckDto} */
export function parseWebsocketHeartbeatAckDto(value) {
  return parseContract("websocket_heartbeat_ack", value)
}

/** @param {unknown} value @returns {WebsocketHeartbeatV2Dto} */
export function parseWebsocketHeartbeatV2Dto(value) {
  return parseContract("websocket_heartbeat_v2", value)
}
